// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.machine-utilization-dashboard {
  --mud-primary: #053c83;
  --mud-secondary: #2f539d;
  --mud-success: #16a34a;
  --mud-warning: #f59e0b;
  --mud-danger: #ef4444;
  position: relative;
  width: 100%;
  padding: 0 0 28px;
  color: #0f172a;
}
.machine-utilization-dashboard * {
  box-sizing: border-box;
}

/* ============================================================
   HERO
============================================================ */
.mud-hero {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 150px;
  margin-bottom: 18px;
  padding: 24px 28px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  background: radial-gradient(circle at 82% 10%, rgba(77, 129, 220, 0.5), transparent 29%), radial-gradient(circle at 20% 120%, rgba(59, 130, 246, 0.33), transparent 32%), linear-gradient(135deg, #032f69 0%, #053c83 47%, #2f539d 100%);
  box-shadow: 0 22px 55px rgba(5, 60, 131, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.12);
}
.mud-hero::before {
  content: "";
  position: absolute;
  right: -90px;
  top: -120px;
  width: 310px;
  height: 310px;
  border: 55px solid rgba(255, 255, 255, 0.045);
  border-radius: 50%;
}
.mud-hero::after {
  content: "";
  position: absolute;
  left: 36%;
  bottom: -125px;
  width: 280px;
  height: 280px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 50%;
}

.mud-hero__content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 18px;
  max-width: 780px;
}
.mud-hero__content h2 {
  margin: 3px 0 6px;
  color: #ffffff;
  font-size: clamp(22px, 2vw, 31px);
  line-height: 1.18;
  font-weight: 650;
  letter-spacing: -0.7px;
}
.mud-hero__content p {
  max-width: 720px;
  margin: 0;
  color: rgba(255, 255, 255, 0.73);
  font-size: 12px;
  line-height: 1.65;
}

.mud-hero__icon {
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 62px;
  height: 62px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 18px;
  color: #ffffff;
  font-size: 28px;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(12px);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.17);
}

.mud-hero__eyebrow {
  color: #bfdbfe;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1.5px;
}

.mud-hero__meta {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  gap: 8px;
  min-width: 330px;
}
.mud-hero__meta > div {
  padding: 11px 13px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
}
.mud-hero__meta > div span {
  display: block;
  margin-bottom: 3px;
  color: rgba(255, 255, 255, 0.58);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.7px;
}
.mud-hero__meta > div strong {
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
}

.mud-hero__live {
  grid-column: 1/-1;
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #dcfce7 !important;
}

.mud-live-dot {
  display: inline-block !important;
  width: 8px;
  height: 8px;
  margin: 0 !important;
  border-radius: 50%;
  background: #4ade80;
  box-shadow: 0 0 0 5px rgba(74, 222, 128, 0.12);
  animation: mudLivePulse 1.8s infinite;
}

@keyframes mudLivePulse {
  0%, 100% {
    box-shadow: 0 0 0 4px rgba(74, 222, 128, 0.12);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(74, 222, 128, 0.03);
  }
}
/* ============================================================
   KPI CARDS
============================================================ */
.mud-kpi-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.mud-kpi-card {
  position: relative;
  overflow: hidden;
  min-height: 132px;
  padding: 16px;
  border: 1px solid #e7edf5;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 6px 24px rgba(15, 23, 42, 0.045), 0 1px 2px rgba(15, 23, 42, 0.03);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.mud-kpi-card:hover {
  transform: translateY(-3px);
  border-color: rgba(5, 60, 131, 0.15);
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.075), 0 2px 4px rgba(15, 23, 42, 0.035);
}

.mud-kpi-card__glow {
  position: absolute;
  right: -30px;
  top: -30px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  opacity: 0.08;
}

.mud-kpi-card__top {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mud-kpi-card__icon {
  display: grid;
  place-items: center;
  width: 37px;
  height: 37px;
  border-radius: 10px;
  font-size: 16px;
}

.mud-kpi-card__label {
  display: block;
  font-size: 18px;
  font-weight: 600;
}

.mud-kpi-card__pulse {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.mud-kpi-card__content {
  position: relative;
  z-index: 1;
  margin-top: 12px;
}
.mud-kpi-card__content .mud-kpi-card__value {
  display: block;
  color: #0f172a;
  font-size: 26px;
  line-height: 1.15;
  font-weight: 700;
  letter-spacing: -0.6px;
}
.mud-kpi-card__content small {
  display: block;
  margin-top: 4px;
  color: #94a3b8;
  font-size: 14px;
}

.mud-kpi-card--primary .mud-kpi-card__icon {
  color: #053c83;
  background: #eaf2ff;
}
.mud-kpi-card--primary .mud-kpi-card__glow {
  background: #053c83;
}
.mud-kpi-card--primary .mud-kpi-card__pulse {
  background: #053c83;
  box-shadow: 0 0 0 4px rgba(5, 60, 131, 0.1);
}

.mud-kpi-card--success .mud-kpi-card__icon {
  color: #16a34a;
  background: #ecfdf3;
}
.mud-kpi-card--success .mud-kpi-card__glow {
  background: #16a34a;
}
.mud-kpi-card--success .mud-kpi-card__pulse {
  background: #16a34a;
  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.1);
}

.mud-kpi-card--warning .mud-kpi-card__icon {
  color: #f59e0b;
  background: #fffbeb;
}
.mud-kpi-card--warning .mud-kpi-card__glow {
  background: #f59e0b;
}
.mud-kpi-card--warning .mud-kpi-card__pulse {
  background: #f59e0b;
  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.1);
}

.mud-kpi-card--danger .mud-kpi-card__icon {
  color: #ef4444;
  background: #fff1f2;
}
.mud-kpi-card--danger .mud-kpi-card__glow {
  background: #ef4444;
}
.mud-kpi-card--danger .mud-kpi-card__pulse {
  background: #ef4444;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
}

.mud-kpi-card--purple .mud-kpi-card__icon {
  color: #7c3aed;
  background: #f5f3ff;
}
.mud-kpi-card--purple .mud-kpi-card__glow {
  background: #7c3aed;
}
.mud-kpi-card--purple .mud-kpi-card__pulse {
  background: #7c3aed;
  box-shadow: 0 0 0 4px rgba(124, 58, 237, 0.1);
}

/* ============================================================
   SECTION CONTAINER
============================================================ */
.mud-section {
  min-width: 0;
  margin-bottom: 0px;
  border: 1px solid #e7edf5;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 7px 26px rgba(15, 23, 42, 0.045), 0 1px 2px rgba(15, 23, 42, 0.02);
}

.mud-section__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 17px 19px 13px;
  border-bottom: 1px solid #edf2f7;
}
.mud-section__header h3 {
  margin: 2px 0 3px;
  color: #0f172a;
  font-size: 20px;
  font-weight: 640;
  letter-spacing: -0.15px;
}
.mud-section__header p {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.mud-section__eyebrow {
  display: inline-block;
  color: #2f539d;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
}

.mud-section__body {
  min-width: 0;
  padding: 19px 19px 19px;
}

.mud-overview-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(310px, 0.7fr);
  gap: 16px;
  margin-bottom: 16px;
}
.mud-overview-grid > .mud-section {
  margin-bottom: 0;
}

.mud-two-column-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}
.mud-two-column-grid > .mud-section {
  margin-bottom: 0;
}

/* ============================================================
   OVERALL UTILIZATION
============================================================ */
.mud-overall-card {
  display: grid;
  grid-template-columns: 270px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.mud-overall-card__chart {
  min-width: 0;
}

.mud-overall-card__details {
  padding: 5px 6px 5px 16px;
}

.mud-overall-card__headline {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 16px;
}
.mud-overall-card__headline span {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}
.mud-overall-card__headline h4 {
  margin: 2px 0 0;
  color: #053c83;
  font-size: 31px;
  line-height: 1;
  font-weight: 850;
  letter-spacing: -1px;
}

.mud-performance-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 14px !important;
  font-weight: 700 !important;
  white-space: nowrap;
}
.mud-performance-badge--success {
  color: #15803d !important;
  background: #dcfce7;
}
.mud-performance-badge--warning {
  color: #b45309 !important;
  background: #fef3c7;
}
.mud-performance-badge--danger {
  color: #b91c1c !important;
  background: #fee2e2;
}
.mud-performance-badge--purple {
  color: #6d28d9 !important;
  background: #ede9fe;
}
.mud-performance-badge--neutral {
  color: #475569 !important;
  background: #f1f5f9;
}

.mud-overall-stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.mud-overall-stats > div {
  padding: 10px 11px;
  border: 1px solid #edf2f7;
  border-radius: 10px;
  background: #fafcff;
}
.mud-overall-stats > div span {
  display: block;
  margin-bottom: 3px;
  color: #64748b;
  font-size: 12px;
}
.mud-overall-stats > div strong {
  color: #0f172a;
  font-size: 16px;
  font-weight: 640;
}

.mud-runtime-progress {
  margin-top: 14px;
}

.mud-runtime-progress__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}
.mud-runtime-progress__header span {
  color: #64748b;
  font-size: 12px;
}
.mud-runtime-progress__header strong {
  color: #053c83;
  font-size: 10px;
}

.mud-runtime-progress__track,
.mud-mini-progress {
  overflow: hidden;
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background: #e8eef7;
}
.mud-runtime-progress__track span,
.mud-mini-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #053c83, #3b82f6);
}

/* ============================================================
   STATUS DONUT
============================================================ */
.mud-donut-layout {
  display: flex;
  flex-direction: column;
}

.mud-status-legend {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.mud-status-legend__item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px;
  border: 1px solid #edf2f7;
  border-radius: 9px;
  background: #fafcff;
}
.mud-status-legend__item > span {
  flex: 0 0 auto;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.mud-status-legend__item > span.running {
  background: #16a34a;
}
.mud-status-legend__item > span.idle {
  background: #f59e0b;
}
.mud-status-legend__item > span.stopped {
  background: #ef4444;
}
.mud-status-legend__item small {
  display: block;
  color: #64748b;
  font-size: 12px;
}
.mud-status-legend__item strong {
  display: block;
  margin-top: 1px;
  color: #0f172a;
  font-size: 16px;
}

/* ============================================================
   RANKING
============================================================ */
.mud-ranking-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.mud-ranking-chart {
  min-width: 0;
  padding: 13px;
  border: 1px solid #edf2f7;
  border-radius: 14px;
  background: #fbfdff;
}

.mud-ranking-chart__title {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 6px;
}
.mud-ranking-chart__title h4 {
  margin: 0;
  color: #0f172a;
  font-size: 15px;
  font-weight: 640;
}
.mud-ranking-chart__title p {
  margin: 2px 0 0;
  color: #64748b;
  font-size: 8px;
}

.mud-ranking-icon {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
}
.mud-ranking-icon--top {
  color: #053c83;
  background: #eaf2ff;
}
.mud-ranking-icon--bottom {
  color: #ef4444;
  background: #fff1f2;
}

/* ============================================================
   CHART TOOLTIP
============================================================ */
.mud-chart-tooltip {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 160px;
  padding: 10px 12px;
}
.mud-chart-tooltip strong {
  color: #0f172a;
  font-size: 14px;
}
.mud-chart-tooltip span {
  color: #64748b;
  font-size: 12px;
}
.mud-chart-tooltip b {
  margin-top: 3px;
  color: #053c83;
  font-size: 14px;
}

/* ============================================================
   HEAT MAP
============================================================ */
.mud-heatmap__legend {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 12px;
}
.mud-heatmap__legend span {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #64748b;
  font-size: 14px;
}
.mud-heatmap__legend span i {
  width: 9px;
  height: 9px;
  border-radius: 3px;
}
.mud-heatmap__legend span i.high {
  background: #16a34a;
}
.mud-heatmap__legend span i.medium {
  background: #f59e0b;
}
.mud-heatmap__legend span i.low {
  background: #ef4444;
}
.mud-heatmap__legend span i.no-data {
  background: #e2e8f0;
}

.mud-heatmap__scroll {
  overflow-x: auto;
  padding-bottom: 5px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.mud-heatmap__grid {
  display: grid;
  min-width: 1080px;
  border: 1px solid #e8eef6;
  border-radius: 12px;
  background: #ffffff;
}

.mud-heatmap__corner,
.mud-heatmap__hour {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 35px;
  border-bottom: 1px solid #e8eef6;
  color: #64748b;
  font-size: 12px;
  font-weight: 640;
  background: #f8fafc;
}

.mud-heatmap__corner {
  justify-content: flex-start;
  padding-left: 12px;
  border-right: 1px solid #e8eef6;
}

.mud-heatmap__row {
  display: grid;
  min-height: 43px;
  border-bottom: 1px solid #edf2f7;
}
.mud-heatmap__row:last-child {
  border-bottom: 0;
}

.mud-heatmap__machine {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px 10px;
  border-right: 1px solid #edf2f7;
}
.mud-heatmap__machine strong {
  color: #0f172a;
  font-size: 12px;
}
.mud-heatmap__machine span {
  overflow: hidden;
  max-width: 125px;
  color: #64748b;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mud-heatmap__cell {
  display: grid;
  place-items: center;
  margin: 4px 3px;
  border-radius: 5px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 12px;
  font-weight: 700;
  cursor: help;
  transition: transform 0.15s ease, filter 0.15s ease;
}
.mud-heatmap__cell:hover {
  transform: scale(1.12);
  filter: brightness(0.95);
}
.mud-heatmap__cell.high {
  background: #16a34a;
}
.mud-heatmap__cell.medium {
  background: #f59e0b;
}
.mud-heatmap__cell.low {
  background: #ef4444;
}
.mud-heatmap__cell.no-data {
  background: #edf2f7;
}

/* ============================================================
   LIVE MACHINE TOOLBAR
============================================================ */
.mud-live-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.mud-search {
  position: relative;
  width: min(360px, 100%);
}
.mud-search i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 11px;
}
.mud-search input {
  width: 100%;
  height: 35px;
  padding: 0 13px 0 34px;
  border: 1px solid #dce5ef;
  border-radius: 9px;
  outline: none;
  color: #0f172a;
  font-size: 10px;
  background: #fafcff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.mud-search input:focus {
  border-color: rgba(5, 60, 131, 0.45);
  box-shadow: 0 0 0 3px rgba(5, 60, 131, 0.07);
}
.mud-search input::placeholder {
  color: #94a3b8;
}

.mud-filter-tabs,
.mud-alert-filter {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  background: #f8fafc;
}
.mud-filter-tabs button,
.mud-alert-filter button {
  padding: 6px 9px;
  border: 0;
  border-radius: 6px;
  color: #64748b;
  font-size: 10px;
  font-weight: 750;
  background: transparent;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}
.mud-filter-tabs button.active,
.mud-alert-filter button.active {
  color: #ffffff;
  background: #053c83;
  box-shadow: 0 3px 8px rgba(5, 60, 131, 0.18);
}

/* ============================================================
   MACHINE CARDS
============================================================ */
.mud-machine-card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 11px;
}

.mud-machine-card {
  position: relative;
  overflow: hidden;
  padding: 13px;
  border: 1px solid #d5d5d5;
  border-radius: 13px;
  background: #fffbfb;
  box-shadow: 0 4px 15px rgba(15, 23, 42, 0.035);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.mud-machine-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 3px;
  height: 100%;
}
.mud-machine-card--running::before {
  background: #16a34a;
}
.mud-machine-card--idle::before {
  background: #f59e0b;
}
.mud-machine-card--stopped::before {
  background: #ef4444;
}
.mud-machine-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 25px rgba(15, 23, 42, 0.075);
}

.mud-machine-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 7px;
}

.mud-machine-card__machine {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}
.mud-machine-card__machine > div {
  min-width: 0;
}
.mud-machine-card__machine strong,
.mud-machine-card__machine small {
  display: block;
}
.mud-machine-card__machine strong {
  color: #0f172a;
  font-size: 14px;
  font-weight: 640;
}
.mud-machine-card__machine small {
  overflow: hidden;
  max-width: 130px;
  margin-top: 1px;
  color: #64748b;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mud-machine-card__icon {
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 29px;
  height: 29px;
  border-radius: 8px;
  color: #053c83;
  font-size: 12px;
  background: #eaf2ff;
}

.mud-live-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}
.mud-live-status i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
}
.mud-live-status.running {
  color: #15803d;
  background: #dcfce7;
}
.mud-live-status.running i {
  background: #16a34a;
}
.mud-live-status.idle {
  color: #b45309;
  background: #fef3c7;
}
.mud-live-status.idle i {
  background: #f59e0b;
}
.mud-live-status.stopped {
  color: #b91c1c;
  background: #fee2e2;
}
.mud-live-status.stopped i {
  background: #ef4444;
}

.mud-machine-card__department {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 9px 0 10px;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
}
.mud-machine-card__department i {
  color: #94a3b8;
}

.mud-machine-card__utilization {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
  margin-bottom: 6px;
}
.mud-machine-card__utilization span {
  color: #64748b;
  font-size: 12px;
}
.mud-machine-card__utilization > div span,
.mud-machine-card__utilization > div strong {
  display: block;
}
.mud-machine-card__utilization > div span {
  color: #64748b;
  font-size: 12px;
}
.mud-machine-card__utilization > div strong {
  margin-top: 1px;
  color: #0f172a;
  font-size: 16px;
  font-weight: 650;
}

.mud-mini-progress {
  height: 4px;
}

.mud-machine-card__metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 4px;
  margin-top: 10px;
}
.mud-machine-card__metrics > div {
  padding: 6px 4px;
  border-radius: 7px;
  text-align: center;
  background: #e9e6e6;
}
.mud-machine-card__metrics > div span,
.mud-machine-card__metrics > div strong {
  display: block;
}
.mud-machine-card__metrics > div span {
  color: #94a3b8;
  font-size: 12px;
}
.mud-machine-card__metrics > div strong {
  overflow: hidden;
  margin-top: 2px;
  color: #0f172a;
  font-size: 14px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mud-machine-card__metrics > div strong.danger {
  color: #ef4444;
}

.mud-machine-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
  margin-top: 9px;
  padding-top: 8px;
  border-top: 1px solid #edf2f7;
}
.mud-machine-card__footer > div {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
}
.mud-machine-card__footer > div i {
  flex: 0 0 auto;
}
.mud-machine-card__footer > div span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mud-jobcard-badge {
  flex: 0 0 auto;
  padding: 3px 12px;
  border-radius: 5px;
  color: #053c83;
  font-size: 12px;
  font-weight: 700;
  background: #eef4ff;
}

.mud-load-more {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.mud-load-more button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 15px;
  border: 1px solid #d9e3ef;
  border-radius: 8px;
  color: #053c83;
  font-size: 14px;
  font-weight: 750;
  background: #ffffff;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.mud-load-more button:hover {
  border-color: rgba(5, 60, 131, 0.25);
  background: #f6f9ff;
}

/* ============================================================
   ALERT PANEL
============================================================ */
.mud-alert-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 10px;
}
.mud-alert-summary > div {
  padding: 10px 12px;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  background: #fafcff;
}
.mud-alert-summary > div span {
  display: block;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
}
.mud-alert-summary > div strong {
  display: block;
  margin-top: 2px;
  color: #0f172a;
  font-size: 17px;
  font-weight: 850;
}
.mud-alert-summary > div.critical {
  border-color: #fecdd3;
  background: #fff1f2;
}
.mud-alert-summary > div.critical strong {
  color: #be123c;
}
.mud-alert-summary > div.warning {
  border-color: #fde68a;
  background: #fffbeb;
}
.mud-alert-summary > div.warning strong {
  color: #b45309;
}
.mud-alert-summary > div.info {
  border-color: #bae6fd;
  background: #f0f9ff;
}
.mud-alert-summary > div.info strong {
  color: #0369a1;
}

.mud-alert-filter {
  width: fit-content;
  margin-bottom: 10px;
}

.mud-alert-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
  max-height: 540px;
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.mud-alert-item {
  display: flex;
  gap: 10px;
  padding: 11px;
  border: 1px solid #e8eef5;
  border-radius: 10px;
  background: #ffffff;
}
.mud-alert-item--critical {
  border-left: 3px solid #e11d48;
}
.mud-alert-item--warning {
  border-left: 3px solid #f59e0b;
}
.mud-alert-item--info {
  border-left: 3px solid #0ea5e9;
}

.mud-alert-item__icon {
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
}
.mud-alert-item--critical .mud-alert-item__icon {
  color: #e11d48;
  background: #fff1f2;
}
.mud-alert-item--warning .mud-alert-item__icon {
  color: #d97706;
  background: #fffbeb;
}
.mud-alert-item--info .mud-alert-item__icon {
  color: #0284c7;
  background: #f0f9ff;
}

.mud-alert-item__body {
  flex: 1 1;
  min-width: 0;
}
.mud-alert-item__body p {
  margin: 5px 0 7px;
  color: #475569;
  font-size: 14px;
  line-height: 1.5;
}

.mud-alert-item__heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}
.mud-alert-item__heading strong {
  display: block;
  color: #0f172a;
  font-size: 15px;
  font-weight: 740;
}
.mud-alert-item__heading span {
  display: block;
  margin-top: 1px;
  color: #64748b;
  font-size: 12px;
}

.mud-alert-severity {
  flex: 0 0 auto;
  padding: 2px 16px;
  border-radius: 999px;
  font-size: 14px !important;
  font-weight: 720;
}
.mud-alert-severity--critical {
  color: #be123c !important;
  background: #ffe4e6;
}
.mud-alert-severity--warning {
  color: #b45309 !important;
  background: #fef3c7;
}
.mud-alert-severity--info {
  color: #0369a1 !important;
  background: #e0f2fe;
}

.mud-alert-item__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px 12px;
}
.mud-alert-item__meta span {
  color: #64748b;
  font-size: 14px;
}
.mud-alert-item__meta span b {
  color: #0f172a;
}

.mud-alert-machine-status {
  padding: 2px 5px;
  border-radius: 4px;
  color: #053c83 !important;
  font-weight: 700;
  background: #eef4ff;
}

/* ============================================================
   EMPTY STATE
============================================================ */
.mud-empty-state {
  display: grid;
  place-items: center;
  min-height: 180px;
  padding: 24px;
  color: #64748b;
  font-size: 10px;
  text-align: center;
  border: 1px dashed #dce5ef;
  border-radius: 10px;
  background: #fbfdff;
}

.mud-no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 360px;
  padding: 30px;
  border: 1px solid #e7edf5;
  border-radius: 18px;
  background: #ffffff;
}
.mud-no-data span {
  display: grid;
  place-items: center;
  width: 60px;
  height: 60px;
  margin-bottom: 12px;
  border-radius: 18px;
  color: #053c83;
  font-size: 27px;
  background: #eaf2ff;
}
.mud-no-data h3 {
  margin: 0;
  font-size: 17px;
}
.mud-no-data p {
  margin: 5px 0 0;
  color: #64748b;
  font-size: 10px;
}

/* ============================================================
   SKELETON
============================================================ */
.mud-skeleton-dashboard {
  padding: 5px 0 25px;
}

@keyframes mudSkeleton {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}
.mud-skeleton-kpis {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

.mud-skeleton-card {
  height: 130px;
  padding: 16px;
  border: 1px solid #e7edf5;
  border-radius: 16px;
  background: white;
}
.mud-skeleton-card span,
.mud-skeleton-card strong,
.mud-skeleton-card small {
  display: block;
  border-radius: 5px;
  background: linear-gradient(90deg, #eef2f7 25%, #f8fafc 50%, #eef2f7 75%);
  background-size: 200% 100%;
  animation: mudSkeleton 1.4s infinite;
}
.mud-skeleton-card span {
  width: 36px;
  height: 36px;
}
.mud-skeleton-card strong {
  width: 70%;
  height: 21px;
  margin-top: 15px;
}
.mud-skeleton-card small {
  width: 45%;
  height: 8px;
  margin-top: 8px;
}

.mud-skeleton-large {
  height: 350px;
  margin-top: 16px;
  padding: 20px;
  border: 1px solid #e7edf5;
  border-radius: 18px;
  background: white;
}
.mud-skeleton-large span {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: linear-gradient(90deg, #eef2f7 25%, #f8fafc 50%, #eef2f7 75%);
  background-size: 200% 100%;
  animation: mudSkeleton 1.4s infinite;
}

.mud-skeleton-two {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 16px;
}
.mud-skeleton-two > div {
  height: 330px;
  padding: 20px;
  border: 1px solid #e7edf5;
  border-radius: 18px;
  background: white;
}
.mud-skeleton-two > div span {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: linear-gradient(90deg, #eef2f7 25%, #f8fafc 50%, #eef2f7 75%);
  background-size: 200% 100%;
  animation: mudSkeleton 1.4s infinite;
}

/* ============================================================
   APEXCHART OVERRIDES
============================================================ */
.machine-utilization-dashboard .apexcharts-tooltip {
  border: 0 !important;
  border-radius: 9px !important;
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.13) !important;
}
.machine-utilization-dashboard .apexcharts-tooltip-title {
  border-bottom: 1px solid #edf2f7 !important;
  font-family: inherit !important;
  font-size: 9px !important;
  background: #f8fafc !important;
}
.machine-utilization-dashboard .apexcharts-legend-text,
.machine-utilization-dashboard .apexcharts-text {
  font-family: inherit !important;
}

/* ============================================================
   RESPONSIVE
============================================================ */
@media (max-width: 1400px) {
  .mud-kpi-grid {
    grid-template-columns: repeat(5, minmax(150px, 1fr));
    overflow-x: auto;
    padding-bottom: 4px;
  }
  .mud-machine-card-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 1150px) {
  .mud-hero {
    flex-direction: column;
    align-items: stretch;
  }
  .mud-hero__meta {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    min-width: 0;
  }
  .mud-hero__live {
    grid-column: auto;
  }
  .mud-overview-grid,
  .mud-two-column-grid {
    grid-template-columns: 1fr;
  }
  .mud-overall-card {
    grid-template-columns: 240px minmax(0, 1fr);
  }
  .mud-ranking-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 900px) {
  .mud-machine-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .mud-live-toolbar {
    flex-direction: column;
    align-items: stretch;
  }
  .mud-search {
    width: 100%;
  }
  .mud-filter-tabs {
    width: fit-content;
  }
}
@media (max-width: 700px) {
  .mud-hero {
    padding: 19px;
  }
  .mud-hero__content {
    align-items: flex-start;
  }
  .mud-hero__icon {
    width: 49px;
    height: 49px;
    border-radius: 13px;
    font-size: 21px;
  }
  .mud-hero__meta {
    grid-template-columns: 1fr;
  }
  .mud-hero__live {
    grid-column: auto;
  }
  .mud-overall-card {
    grid-template-columns: 1fr;
  }
  .mud-overall-card__details {
    padding: 0;
  }
  .mud-machine-card-grid {
    grid-template-columns: 1fr;
  }
  .mud-alert-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .mud-section__body {
    padding: 14px;
  }
  .mud-section__header {
    padding: 15px 14px 12px;
  }
}
/* =========================================================
   MACHINE STATUS DONUT
========================================================= */
.mud-machine-status {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
}

/* =========================================================
   MAIN LAYOUT
========================================================= */
.mud-donut-layout {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
}

/* =========================================================
   DONUT CHART WRAPPER
========================================================= */
.mud-donut-chart-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 270px;
  overflow: hidden;
  isolation: isolate;
}
.mud-donut-chart-wrapper .apexcharts-canvas {
  position: relative;
  z-index: 2;
  max-width: 100% !important;
}
.mud-donut-chart-wrapper .apexcharts-svg {
  max-width: 100% !important;
}
.mud-donut-chart-wrapper .apexcharts-pie {
  cursor: pointer;
}
.mud-donut-chart-wrapper .apexcharts-pie-area {
  cursor: pointer;
  transition: opacity 0.25s ease, filter 0.25s ease;
}

/* =========================================================
   DONUT BACKGROUND GLOW
========================================================= */
.mud-donut-glow {
  position: absolute;
  z-index: 0;
  width: 175px;
  height: 175px;
  border-radius: 50%;
  opacity: 0.8;
  filter: blur(40px);
  pointer-events: none;
  transition: background-color 0.5s ease, opacity 0.6s ease, transform 0.5s ease;
  animation: mudDonutGlow 3s ease-in-out infinite;
}

@keyframes mudDonutGlow {
  0%, 100% {
    opacity: 0.06;
    transform: scale(0.9);
  }
  50% {
    opacity: 0.15;
    transform: scale(1.15);
  }
}
/* =========================================================
   CUSTOM DONUT CENTER CONTENT
========================================================= */
.mud-donut-center-content {
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 105px;
  height: 105px;
  padding: 4px;
  text-align: center;
  pointer-events: none;
  box-sizing: border-box;
  animation: mudDonutCenterEnter 0.55s cubic-bezier(0.16, 1, 0.3, 1);
  /* -----------------------------------------
     STATUS NAME
  ----------------------------------------- */
  /* -----------------------------------------
     STATUS DOT
  ----------------------------------------- */
  /* -----------------------------------------
     MACHINE COUNT
  ----------------------------------------- */
  /* -----------------------------------------
     PERCENTAGE
  ----------------------------------------- */
}
.mud-donut-center-content__status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  max-width: 100%;
  margin-bottom: 5px;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0.45px;
  text-transform: uppercase;
  white-space: nowrap;
  transition: color 0.4s ease;
}
.mud-donut-center-content__status > span:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
}
.mud-donut-center-content__dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  border-radius: 50%;
  transition: background-color 0.4s ease, box-shadow 0.4s ease;
  animation: mudCenterStatusPulse 1.8s ease-in-out infinite;
}
.mud-donut-center-content__value {
  display: block;
  margin: 1px 0;
  font-size: 31px;
  font-weight: 850;
  line-height: 1;
  letter-spacing: -1.3px;
  transition: color 0.4s ease;
  animation: mudCenterValueEnter 0.55s cubic-bezier(0.16, 1, 0.3, 1);
}
.mud-donut-center-content__percentage {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 6px;
}
.mud-donut-center-content__percentage span {
  padding: 3px 6px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-size: 9px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}
.mud-donut-center-content__percentage small {
  color: #94a3b8;
  font-size: 8px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

/* =========================================================
   CENTER CONTENT ENTER ANIMATION
========================================================= */
@keyframes mudDonutCenterEnter {
  0% {
    opacity: 0;
    transform: translate(-50%, -43%) scale(0.82);
  }
  65% {
    opacity: 1;
    transform: translate(-50%, -51%) scale(1.04);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
@keyframes mudCenterValueEnter {
  0% {
    opacity: 0;
    transform: translateY(8px) scale(0.8);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes mudCenterStatusPulse {
  0%, 100% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.35);
  }
}
/* =========================================================
   RIGHT STATUS CONTENT
========================================================= */
.mud-status-content {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
}
.mud-status-content__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-width: 0;
  margin-bottom: 14px;
}
.mud-status-content__summary {
  min-width: 0;
}
.mud-status-content__eyebrow {
  display: block;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.55px;
  text-transform: uppercase;
  white-space: nowrap;
}
.mud-status-content h4 {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 5px;
  margin: 3px 0 0;
  color: #0f172a;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.6px;
}
.mud-status-content h4 small {
  color: #64748b;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0;
  white-space: nowrap;
}

/* =========================================================
   LIVE / PAUSED BUTTON
========================================================= */
.mud-auto-rotate {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  min-height: 28px;
  padding: 5px 9px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #ffffff;
  color: #64748b;
  font-family: inherit;
  font-size: 9px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease, color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}
.mud-auto-rotate:hover {
  border-color: #cbd5e1;
  transform: translateY(-1px);
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.07);
}
.mud-auto-rotate__indicator {
  position: relative;
  width: 7px;
  height: 7px;
  flex: 0 0 7px;
  border-radius: 50%;
  background: #94a3b8;
}
.mud-auto-rotate.is-playing {
  color: #15803d;
  border-color: #bbf7d0;
  background: #f0fdf4;
  font-size: 12px;
  margin-top: 22px;
}
.mud-auto-rotate.is-playing .mud-auto-rotate__indicator {
  background: #22c55e;
}
.mud-auto-rotate.is-playing .mud-auto-rotate__indicator::after {
  position: absolute;
  inset: -4px;
  content: "";
  border: 1px solid rgba(34, 197, 94, 0.4);
  border-radius: 50%;
  animation: mudLivePulse 1.6s ease-out infinite;
}
.mud-auto-rotate.is-paused {
  color: #64748b;
  border-color: #e2e8f0;
  background: #f8fafc;
  margin-top: 22px;
}

@keyframes mudLivePulse {
  0% {
    opacity: 1;
    transform: scale(0.5);
  }
  100% {
    opacity: 0;
    transform: scale(1.8);
  }
}
/* =========================================================
   STATUS CARDS
========================================================= */
.mud-status-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  /* -----------------------------------------
     CARD
  ----------------------------------------- */
  /* -----------------------------------------
     CARD TOP
  ----------------------------------------- */
  /* -----------------------------------------
     ICON
  ----------------------------------------- */
  /* -----------------------------------------
     LABEL + VALUE
  ----------------------------------------- */
  /* -----------------------------------------
     PERCENTAGE BADGE
  ----------------------------------------- */
  /* -----------------------------------------
     PROGRESS BAR
  ----------------------------------------- */
}
.mud-status-legend__item {
  position: relative;
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 10px 10px 9px;
  overflow: hidden;
  border: 1px solid #e8edf4;
  border-radius: 11px;
  background: #ffffff;
  color: inherit;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  box-sizing: border-box;
  transform: translateX(0);
  transition: border-color 0.25s ease, background-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
}
.mud-status-legend__item::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  content: "";
  background: var(--status-color);
  opacity: 0;
  transform: scaleY(0.3);
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.mud-status-legend__item:hover {
  border-color: var(--status-color);
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.06);
}
.mud-status-legend__item.is-active {
  border-color: var(--status-color);
  background: linear-gradient(90deg, var(--status-light) 0%, rgba(255, 255, 255, 0.98) 72%);
  box-shadow: inset 3px 0 0 var(--status-color), 0 6px 16px rgba(15, 23, 42, 0.06);
}
.mud-status-legend__item.is-active::before {
  opacity: 1;
  transform: scaleY(1);
}
.mud-status-legend__item.is-active .mud-status-legend__icon {
  background: var(--status-light);
  transform: scale(1.05);
}
.mud-status-legend__item.is-active .mud-status-legend__progress span {
  opacity: 1;
}
.mud-status-legend__top {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  width: 100%;
  min-width: 0;
}
.mud-status-legend__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  border-radius: 9px;
  background: #f8fafc;
  transition: transform 0.25s ease, background-color 0.25s ease;
}
.mud-status-legend__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--status-color);
  box-shadow: 0 0 0 4px var(--status-light);
}
.mud-status-legend__label {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}
.mud-status-legend__label small {
  min-width: 0;
  overflow: hidden;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mud-status-legend__label strong {
  flex-shrink: 0;
  color: #0f172a;
  font-size: 16px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.3px;
}
.mud-status-legend__percentage {
  flex-shrink: 0;
  padding: 3px 6px;
  border-radius: 999px;
  background: var(--status-light);
  color: var(--status-color);
  font-size: 10px;
  font-weight: 660;
  white-space: nowrap;
}
.mud-status-legend__progress {
  height: 3px;
  margin-top: 7px;
  margin-left: 37px;
  overflow: hidden;
  border-radius: 999px;
  background: #f1f5f9;
}
.mud-status-legend__progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--status-color);
  opacity: 0.8;
  transition: width 0.8s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.25s ease;
}

/* =========================================================
   DONUT TOOLTIP
========================================================= */
.mud-donut-tooltip {
  min-width: 150px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.14);
}
.mud-donut-tooltip__header {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 7px;
  color: #334155;
  font-size: 11px;
}
.mud-donut-tooltip__dot {
  width: 8px;
  height: 8px;
  flex: 0 0 8px;
  border-radius: 50%;
}
.mud-donut-tooltip__body {
  display: flex;
  align-items: baseline;
  gap: 5px;
}
.mud-donut-tooltip__body strong {
  color: #0f172a;
  font-size: 20px;
  font-weight: 800;
}
.mud-donut-tooltip__body span {
  color: #64748b;
  font-size: 10px;
  font-weight: 600;
}
.mud-donut-tooltip__percentage {
  margin-top: 3px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 600;
}

/* =========================================================
   RESPONSIVE - LARGE TABLET
========================================================= */
@media (max-width: 1400px) {
  .mud-donut-layout {
    grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);
    gap: 8px;
  }
  .mud-status-content h4 {
    font-size: 21px;
  }
}
/* =========================================================
   RESPONSIVE - LAPTOP
========================================================= */
@media (max-width: 1200px) {
  .mud-donut-layout {
    grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
    gap: 6px;
  }
  .mud-donut-chart-wrapper {
    min-height: 250px;
  }
  .mud-donut-center-content {
    width: 92px;
    height: 92px;
  }
  .mud-donut-center-content__status {
    gap: 5px;
    font-size: 9px;
  }
  .mud-donut-center-content__value {
    font-size: 27px;
  }
  .mud-donut-center-content__percentage span {
    font-size: 8px;
  }
  .mud-donut-center-content__percentage small {
    font-size: 7px;
  }
  .mud-status-content__header {
    margin-bottom: 10px;
  }
  .mud-status-content h4 {
    font-size: 19px;
  }
  .mud-status-content h4 small {
    font-size: 9px;
  }
  .mud-status-legend {
    gap: 6px;
  }
  .mud-status-legend__item {
    padding: 8px 8px 7px;
  }
  .mud-status-legend__top {
    grid-template-columns: 27px minmax(0, 1fr) auto;
    gap: 5px;
  }
  .mud-status-legend__icon {
    width: 27px;
    height: 27px;
    flex-basis: 27px;
  }
  .mud-status-legend__label small {
    font-size: 9px;
  }
  .mud-status-legend__label strong {
    font-size: 14px;
  }
  .mud-status-legend__percentage {
    padding: 2px 5px;
    font-size: 8px;
  }
  .mud-status-legend__progress {
    margin-left: 32px;
  }
}
/* =========================================================
   RESPONSIVE - TABLET / SMALLER CARD
========================================================= */
@media (max-width: 992px) {
  .mud-donut-layout {
    grid-template-columns: 1fr;
    gap: 5px;
  }
  .mud-donut-chart-wrapper {
    min-height: 235px;
  }
  .mud-status-content {
    width: 100%;
    max-width: 100%;
  }
}
/* =========================================================
   RESPONSIVE - MOBILE
========================================================= */
@media (max-width: 575px) {
  .mud-donut-chart-wrapper {
    min-height: 220px;
  }
  .mud-donut-center-content {
    width: 88px;
    height: 88px;
  }
  .mud-donut-center-content__status {
    font-size: 8px;
  }
  .mud-donut-center-content__value {
    font-size: 25px;
  }
  .mud-donut-center-content__percentage small {
    display: none;
  }
  .mud-status-content__header {
    align-items: center;
  }
  .mud-status-content h4 {
    font-size: 20px;
  }
  .mud-status-legend__item {
    padding: 9px;
  }
  .mud-status-legend__top {
    grid-template-columns: 28px minmax(0, 1fr) auto;
  }
  .mud-status-legend__icon {
    width: 28px;
    height: 28px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/Dashboard/MachineUtilizationDashboard/MachineUtilizationDashboard.scss"],"names":[],"mappings":"AAmBA;EACE,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EAEA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAlBa;AADf;AAqBE;EACE,sBAAA;AAnBJ;;AAuBA;;8DAAA;AAIA;EACE,kBAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EAEA,iBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,2CAAA;EACA,mBAAA;EAEA,wOACE;EAQF,uFACE;AAlCJ;AAqCE;EACE,WAAA;EAEA,kBAAA;EACA,YAAA;EACA,WAAA;EAEA,YAAA;EACA,aAAA;EAEA,6CAAA;EACA,kBAAA;AAtCJ;AAyCE;EACE,WAAA;EAEA,kBAAA;EACA,SAAA;EACA,cAAA;EAEA,YAAA;EACA,aAAA;EAEA,2CAAA;EACA,kBAAA;AA1CJ;;AA8CA;EACE,kBAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,gBAAA;AA7CF;AA+CE;EACE,iBAAA;EAEA,cAAA;EACA,iCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AA9CJ;AAiDE;EACE,gBAAA;EACA,SAAA;EAEA,gCAAA;EACA,eAAA;EACA,iBAAA;AAhDJ;;AAoDA;EACE,cAAA;EAEA,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EAEA,0CAAA;EACA,mBAAA;EAEA,cAAA;EACA,eAAA;EAEA,qCAAA;EACA,2BAAA;EAEA,mDAAA;AAvDF;;AA0DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAvDF;;AA0DA;EACE,kBAAA;EACA,UAAA;EAEA,aAAA;EACA,oDAAA;EACA,QAAA;EAEA,gBAAA;AAzDF;AA2DE;EACE,kBAAA;EAEA,2CAAA;EACA,mBAAA;EAEA,qCAAA;EACA,2BAAA;AA3DJ;AA6DI;EACE,cAAA;EAEA,kBAAA;EAEA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AA7DN;AAgEI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA9DN;;AAmEA;EACE,iBAAA;EAEA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EAEA,yBAAA;AAlEF;;AAqEA;EACE,gCAAA;EAEA,UAAA;EACA,WAAA;EACA,oBAAA;EAEA,kBAAA;EACA,mBAAA;EAEA,8CAAA;EAEA,qCAAA;AAtEF;;AAyEA;EAEE;IAEE,8CAAA;EAxEF;EA2EA;IACE,8CAAA;EAzEF;AACF;AA4EA;;8DAAA;AAIA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EAEA,mBAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,gBAAA;EAEA,iBAAA;EACA,aAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBA/OQ;EAiPR,gFACE;EAGF,6EACE;AApFJ;AAwFE;EACE,2BAAA;EAEA,oCAAA;EAEA,kFACE;AAzFN;;AA8FA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EAEA,YAAA;EACA,aAAA;EAEA,kBAAA;EACA,aAAA;AA7FF;;AAgGA;EACE,kBAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;AA9FF;;AAiGA;EACE,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EAEA,mBAAA;EAEA,eAAA;AAjGF;;AAoGA;EACE,cAAA;EAGA,eAAA;EACA,gBAAA;AAnGF;;AAuGA;EACE,UAAA;EACA,WAAA;EAEA,kBAAA;AArGF;;AAwGA;EACE,kBAAA;EACA,UAAA;EAEA,gBAAA;AAtGF;AAyGE;EACE,cAAA;EAEA,cArUW;EAsUX,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAxGJ;AA2GE;EACE,cAAA;EAEA,eAAA;EAEA,cAAA;EACA,eAAA;AA3GJ;;AAgHE;EACE,cAjWM;EAkWN,mBAc0B;AA3H9B;AAgHE;EACE,mBAtWM;AAwPV;AAiHE;EACE,mBA1WM;EA2WN,2CAAA;AA/GJ;;AAoGE;EACE,cA9VM;EA+VN,mBAkB0B;AAnH9B;AAoGE;EACE,mBAnWM;AAiQV;AAqGE;EACE,mBAvWM;EAwWN,4CAAA;AAnGJ;;AAwFE;EACE,cA7VM;EA8VN,mBAsB0B;AA3G9B;AAwFE;EACE,mBAlWM;AA4QV;AAyFE;EACE,mBAtWM;EAuWN,6CAAA;AAvFJ;;AA4EE;EACE,cA5VK;EA6VL,mBA0ByB;AAnG7B;AA4EE;EACE,mBAjWK;AAuRT;AA6EE;EACE,mBArWK;EAsWL,4CAAA;AA3EJ;;AAgEE;EACE,cA3VK;EA4VL,mBA8ByB;AA3F7B;AAgEE;EACE,mBAhWK;AAkST;AAiEE;EACE,mBApWK;EAqWL,6CAAA;AA/DJ;;AAuFA;;8DAAA;AAIA;EACE,YAAA;EACA,kBAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBAhYQ;EAkYR,gFACE;AAzFJ;;AA6FA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EAEA,uBAAA;EAEA,gCAAA;AA5FF;AA8FE;EACE,iBAAA;EAEA,cAzZW;EA0ZX,eAAA;EACA,gBAAA;EACA,uBAAA;AA7FJ;AAgGE;EACE,SAAA;EAEA,cAhaS;EAiaT,eAAA;EACA,gBAAA;AA/FJ;;AAmGA;EACE,qBAAA;EAEA,cAnbU;EAobV,eAAA;EACA,gBAAA;EACA,mBAAA;AAjGF;;AAoGA;EACE,YAAA;EACA,uBAAA;AAjGF;;AAoGA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EAMA,mBAAA;AAtGF;AAkGE;EACE,gBAAA;AAhGJ;;AAsGA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EAMA,mBAAA;AAxGF;AAoGE;EACE,gBAAA;AAlGJ;;AAwGA;;8DAAA;AAIA;EACE,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,QAAA;AAtGF;;AAyGA;EACE,YAAA;AAtGF;;AAyGA;EACE,yBAAA;AAtGF;;AAyGA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EAEA,mBAAA;AAvGF;AAyGE;EACE,cAxeS;EAyeT,eAAA;EACA,gBAAA;AAvGJ;AA0GE;EACE,eAAA;EAEA,cA3fM;EA4fN,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;AAzGJ;;AA6GA;EACE,oBAAA;EACA,mBAAA;EAEA,iBAAA;EAEA,oBAAA;EAEA,0BAAA;EACA,2BAAA;EACA,mBAAA;AA7GF;AA+GE;EACE,yBAAA;EACA,mBAAA;AA7GJ;AAgHE;EACE,yBAAA;EACA,mBAAA;AA9GJ;AAiHE;EACE,yBAAA;EACA,mBAAA;AA/GJ;AAkHE;EACE,yBAAA;EACA,mBAAA;AAhHJ;AAmHE;EACE,yBAAA;EACA,mBAAA;AAjHJ;;AAqHA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AAlHF;AAoHE;EACE,kBAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBAAA;AApHJ;AAsHI;EACE,cAAA;EAEA,kBAAA;EAEA,cAhjBO;EAijBP,eAAA;AAtHN;AAyHI;EACE,cAvjBS;EAwjBT,eAAA;EACA,gBAAA;AAvHN;;AA4HA;EACE,gBAAA;AAzHF;;AA4HA;EACE,aAAA;EACA,8BAAA;EAEA,kBAAA;AA1HF;AA4HE;EACE,cAvkBS;EAwkBT,eAAA;AA1HJ;AA6HE;EACE,cAvlBM;EAwlBN,eAAA;AA3HJ;;AA+HA;;EAEE,gBAAA;EAEA,WAAA;EACA,WAAA;EAEA,oBAAA;EACA,mBAAA;AA9HF;AAgIE;;EACE,cAAA;EAEA,YAAA;EAEA,sBAAA;EAEA,oDAAA;AAhIJ;;AAoIA;;8DAAA;AAIA;EACE,aAAA;EACA,sBAAA;AAlIF;;AAqIA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AAlIF;;AAqIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,YAAA;EAEA,yBAAA;EACA,kBAAA;EAEA,mBAAA;AArIF;AAuIE;EACE,cAAA;EAEA,UAAA;EACA,WAAA;EAEA,kBAAA;AAvIJ;AAyII;EACE,mBAlpBI;AA2gBV;AA0II;EACE,mBArpBI;AA6gBV;AA2II;EACE,mBAxpBG;AA+gBT;AA6IE;EACE,cAAA;EAEA,cAzpBS;EA0pBT,eAAA;AA5IJ;AA+IE;EACE,cAAA;EAEA,eAAA;EAEA,cApqBW;EAqqBX,eAAA;AA/IJ;;AAmJA;;8DAAA;AAIA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAjJF;;AAoJA;EACE,YAAA;EACA,aAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBAAA;AAnJF;;AAsJA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,kBAAA;AApJF;AAsJE;EACE,SAAA;EAEA,cAvsBW;EAwsBX,eAAA;EACA,gBAAA;AArJJ;AAwJE;EACE,eAAA;EAEA,cA7sBS;EA8sBT,cAAA;AAvJJ;;AA2JA;EACE,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;AA1JF;AA4JE;EACE,cAvuBM;EAwuBN,mBAAA;AA1JJ;AA6JE;EACE,cAvuBK;EAwuBL,mBAAA;AA3JJ;;AA+JA;;8DAAA;AAIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,gBAAA;EACA,kBAAA;AA9JF;AAgKE;EACE,cArvBW;EAsvBX,eAAA;AA9JJ;AAiKE;EACE,cAxvBS;EAyvBT,eAAA;AA/JJ;AAkKE;EACE,eAAA;EAEA,cA1wBM;EA2wBN,eAAA;AAjKJ;;AAqKA;;8DAAA;AAIA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EAEA,mBAAA;AApKF;AAsKE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,cApxBS;EAqxBT,eAAA;AArKJ;AAuKI;EACE,UAAA;EACA,WAAA;EAEA,kBAAA;AAtKN;AAwKM;EACE,mBAAA;AAtKR;AAyKM;EACE,mBAAA;AAvKR;AA0KM;EACE,mBAAA;AAxKR;AA2KM;EACE,mBAAA;AAzKR;;AA+KA;EACE,gBAAA;EAEA,mBAAA;EAEA,qBAAA;EACA,oCAAA;AA9KF;;AAiLA;EACE,aAAA;EAEA,iBAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBAAA;AAjLF;;AAoLA;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,gBAAA;EAEA,gCAAA;EAEA,cA90BW;EA+0BX,eAAA;EACA,gBAAA;EAEA,mBAAA;AArLF;;AAwLA;EACE,2BAAA;EAEA,kBAAA;EAEA,+BAAA;AAvLF;;AA0LA;EACE,aAAA;EAEA,gBAAA;EAEA,gCAAA;AAzLF;AA2LE;EACE,gBAAA;AAzLJ;;AA6LA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EAEA,iBAAA;EAEA,+BAAA;AA5LF;AA8LE;EACE,cAr3BW;EAs3BX,eAAA;AA5LJ;AA+LE;EACE,gBAAA;EAEA,gBAAA;EAEA,cA53BS;EA63BT,cAAA;EAEA,uBAAA;EACA,mBAAA;AAhMJ;;AAoMA;EACE,aAAA;EACA,mBAAA;EAEA,eAAA;EAEA,kBAAA;EAEA,gCAAA;EACA,eAAA;EACA,gBAAA;EAEA,YAAA;EAEA,mDACE;AAvMJ;AA0ME;EACE,sBAAA;EACA,wBAAA;AAxMJ;AA2ME;EACE,mBAAA;AAzMJ;AA4ME;EACE,mBAAA;AA1MJ;AA6ME;EACE,mBAAA;AA3MJ;AA8ME;EACE,mBAAA;AA5MJ;;AAgNA;;8DAAA;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EAEA,mBAAA;AA/MF;;AAkNA;EACE,kBAAA;EAEA,uBAAA;AAhNF;AAkNE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EAEA,2BAAA;EAEA,cAAA;EACA,eAAA;AAlNJ;AAqNE;EACE,WAAA;EACA,YAAA;EAEA,sBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,aAAA;EAEA,cAr9BW;EAs9BX,eAAA;EAEA,mBAAA;EAEA,wDACE;AAzNN;AA4NI;EACE,oCAAA;EAEA,4CAAA;AA3NN;AA8NI;EACE,cAAA;AA5NN;;AAiOA;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,YAAA;EAEA,yBAAA;EACA,kBAAA;EAEA,mBAAA;AAjOF;AAmOE;;EACE,gBAAA;EAEA,SAAA;EACA,kBAAA;EAEA,cA3/BS;EA4/BT,eAAA;EACA,gBAAA;EAEA,uBAAA;EAEA,eAAA;EAEA,0EACE;AAtON;AA0OI;;EACE,cAAA;EACA,mBArhCI;EAuhCJ,4CAAA;AAxON;;AA6OA;;8DAAA;AAIA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AA3OF;;AA8OA;EACE,kBAAA;EACA,gBAAA;EAEA,aAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,8CAAA;EAEA,uDACE;AAjPJ;AAoPE;EACE,WAAA;EAEA,kBAAA;EACA,OAAA;EACA,MAAA;EAEA,UAAA;EACA,YAAA;AApPJ;AAuPE;EACE,mBAhkCM;AA20BV;AAwPE;EACE,mBAnkCM;AA60BV;AAyPE;EACE,mBAtkCK;AA+0BT;AA0PE;EACE,2BAAA;EAEA,+CAAA;AAzPJ;;AA6PA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;AA1PF;;AA6PA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,YAAA;AA3PF;AA6PE;EACE,YAAA;AA3PJ;AA8PE;;EAEE,cAAA;AA5PJ;AA+PE;EACE,cApmCW;EAqmCX,eAAA;EACA,gBAAA;AA7PJ;AAgQE;EACE,gBAAA;EAEA,gBAAA;EAEA,eAAA;EAEA,cA9mCS;EA+mCT,eAAA;EAEA,uBAAA;EACA,mBAAA;AAlQJ;;AAsQA;EACE,cAAA;EAEA,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;EAEA,cA5oCQ;EA6oCR,eAAA;EAEA,mBAAA;AAxQF;;AA2QA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EAEA,iBAAA;EAEA,oBAAA;EAEA,eAAA;EACA,gBAAA;AA3QF;AA6QE;EACE,UAAA;EACA,WAAA;EAEA,kBAAA;AA5QJ;AA+QE;EACE,cAAA;EACA,mBAAA;AA7QJ;AA+QI;EACE,mBAvqCI;AA05BV;AAiRE;EACE,cAAA;EACA,mBAAA;AA/QJ;AAiRI;EACE,mBA/qCI;AAg6BV;AAmRE;EACE,cAAA;EACA,mBAAA;AAjRJ;AAmRI;EACE,mBAvrCG;AAs6BT;;AAsRA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,kBAAA;EAEA,cA7rCW;EA8rCX,eAAA;EACA,gBAAA;AArRF;AAuRE;EACE,cAAA;AArRJ;;AAyRA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EAEA,kBAAA;AAvRF;AAyRE;EACE,cA/sCS;EAgtCT,eAAA;AAvRJ;AA4RI;;EAEE,cAAA;AA1RN;AA6RI;EACE,cA3tCO;EA4tCP,eAAA;AA3RN;AA8RI;EACE,eAAA;EAEA,cApuCS;EAquCT,eAAA;EACA,gBAAA;AA7RN;;AAkSA;EACE,WAAA;AA/RF;;AAkSA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;EAEA,gBAAA;AAhSF;AAkSE;EACE,gBAAA;EAEA,kBAAA;EAEA,kBAAA;EAEA,mBAAA;AAnSJ;AAqSI;;EAEE,cAAA;AAnSN;AAsSI;EACE,cAAA;EACA,eAAA;AApSN;AAuSI;EACE,gBAAA;EAEA,eAAA;EAEA,cA9wCS;EA+wCT,eAAA;EACA,gBAAA;EAEA,uBAAA;EACA,mBAAA;AAxSN;AA0SM;EACE,cA1xCC;AAk/BT;;AA8SA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EAEA,eAAA;EACA,gBAAA;EAEA,6BAAA;AA7SF;AA+SE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,YAAA;EAEA,cA5yCS;EA6yCT,eAAA;EACA,gBAAA;EACA,mBAAA;AA/SJ;AAiTI;EACE,cAAA;AA/SN;AAkTI;EACE,gBAAA;EAEA,uBAAA;EACA,mBAAA;AAjTN;;AAsTA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAnTF;;AAsTA;EACE,aAAA;EACA,uBAAA;EAEA,gBAAA;AApTF;AAsTE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EAEA,iBAAA;EAEA,yBAAA;EACA,kBAAA;EAEA,cAn2CM;EAo2CN,eAAA;EACA,gBAAA;EAEA,mBAAA;EAEA,eAAA;EAEA,0DACE;AA3TN;AA8TI;EACE,oCAAA;EACA,mBAAA;AA5TN;;AAiUA;;8DAAA;AAIA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;EAEA,mBAAA;AAhUF;AAkUE;EACE,kBAAA;EAEA,yBAAA;EACA,kBAAA;EAEA,mBAAA;AAlUJ;AAoUI;EACE,cAAA;EAEA,cAj4CO;EAk4CP,eAAA;EACA,gBAAA;AAnUN;AAsUI;EACE,cAAA;EAEA,eAAA;EAEA,cA74CS;EA84CT,eAAA;EACA,gBAAA;AAtUN;AAyUI;EACE,qBAAA;EACA,mBAAA;AAvUN;AAyUM;EACE,cAAA;AAvUR;AA2UI;EACE,qBAAA;EACA,mBAAA;AAzUN;AA2UM;EACE,cAAA;AAzUR;AA6UI;EACE,qBAAA;EACA,mBAAA;AA3UN;AA6UM;EACE,cAAA;AA3UR;;AAiVA;EACE,kBAAA;EACA,mBAAA;AA9UF;;AAiVA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,iBAAA;EACA,gBAAA;EAEA,kBAAA;EAEA,qBAAA;EACA,oCAAA;AAjVF;;AAoVA;EACE,aAAA;EACA,SAAA;EAEA,aAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBAAA;AApVF;AAsVE;EACE,8BAAA;AApVJ;AAuVE;EACE,8BAAA;AArVJ;AAwVE;EACE,8BAAA;AAtVJ;;AA0VA;EACE,cAAA;EAEA,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;AA1VF;AA4VE;EACE,cAAA;EACA,mBAAA;AA1VJ;AA6VE;EACE,cAAA;EACA,mBAAA;AA3VJ;AA8VE;EACE,cAAA;EACA,mBAAA;AA5VJ;;AAgWA;EACE,SAAA;EACA,YAAA;AA7VF;AA+VE;EACE,iBAAA;EAEA,cA3/Ca;EA4/Cb,eAAA;EACA,gBAAA;AA9VJ;;AAkWA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AA/VF;AAiWE;EACE,cAAA;EAEA,cA3gDW;EA4gDX,eAAA;EACA,gBAAA;AAhWJ;AAmWE;EACE,cAAA;EAEA,eAAA;EAEA,cAnhDS;EAohDT,eAAA;AAnWJ;;AAuWA;EACE,cAAA;EAEA,iBAAA;EAEA,oBAAA;EAEA,0BAAA;EACA,gBAAA;AAvWF;AAyWE;EACE,yBAAA;EACA,mBAAA;AAvWJ;AA0WE;EACE,yBAAA;EACA,mBAAA;AAxWJ;AA2WE;EACE,yBAAA;EACA,mBAAA;AAzWJ;;AA6WA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;AA1WF;AA4WE;EACE,cAzjDS;EA0jDT,eAAA;AA1WJ;AA4WI;EACE,cA/jDS;AAqtCf;;AA+WA;EACE,gBAAA;EAEA,kBAAA;EAEA,yBAAA;EACA,gBAAA;EAEA,mBAAA;AA/WF;;AAkXA;;8DAAA;AAIA;EACE,aAAA;EACA,mBAAA;EAEA,iBAAA;EACA,aAAA;EAEA,cAxlDW;EAylDX,eAAA;EACA,kBAAA;EAEA,0BAAA;EACA,mBAAA;EAEA,mBAAA;AApXF;;AAuXA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EACA,aAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBAAA;AAvXF;AAyXE;EACE,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EAEA,mBAAA;EAEA,mBAAA;EAEA,cAtoDM;EAuoDN,eAAA;EAEA,mBAAA;AA5XJ;AA+XE;EACE,SAAA;EAEA,eAAA;AA9XJ;AAiYE;EACE,eAAA;EAEA,cA1oDS;EA2oDT,eAAA;AAhYJ;;AAoYA;;8DAAA;AAIA;EACE,mBAAA;AAlYF;;AAgZA;EACE;IACE,2BAAA;EA7YF;EAgZA;IACE,4BAAA;EA9YF;AACF;AAiZA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AA/YF;;AAkZA;EACE,aAAA;EACA,aAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,iBAAA;AAjZF;AAmZE;;;EAGE,cAAA;EAEA,kBAAA;EAxCF,yEAAA;EAKA,0BAAA;EAEA,oCAAA;AA9WF;AAoZE;EACE,WAAA;EACA,YAAA;AAlZJ;AAqZE;EACE,UAAA;EACA,YAAA;EAEA,gBAAA;AApZJ;AAuZE;EACE,UAAA;EACA,WAAA;EAEA,eAAA;AAtZJ;;AA0ZA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,iBAAA;AAzZF;AA2ZE;EACE,cAAA;EAEA,WAAA;EACA,YAAA;EAEA,mBAAA;EAjFF,yEAAA;EAKA,0BAAA;EAEA,oCAAA;AA9UF;;AA8ZA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EAEA,gBAAA;AA5ZF;AA8ZE;EACE,aAAA;EACA,aAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,iBAAA;AA9ZJ;AAgaI;EACE,cAAA;EAEA,WAAA;EACA,YAAA;EAEA,mBAAA;EA7GJ,yEAAA;EAKA,0BAAA;EAEA,oCAAA;AAvTF;;AAoaA;;8DAAA;AAKE;EACE,oBAAA;EACA,6BAAA;EAEA,wDAAA;AApaJ;AAuaE;EACE,2CAAA;EAEA,+BAAA;EACA,yBAAA;EAEA,8BAAA;AAvaJ;AA0aE;;EAEE,+BAAA;AAxaJ;;AA4aA;;8DAAA;AAIA;EACE;IACE,oDAAA;IACA,gBAAA;IAEA,mBAAA;EA3aF;EA8aA;IACE,gDAAA;EA5aF;AACF;AA+aA;EACE;IACE,sBAAA;IACA,oBAAA;EA7aF;EAgbA;IACE,gDAAA;IAEA,YAAA;EA/aF;EAkbA;IACE,iBAAA;EAhbF;EAmbA;;IAEE,0BAAA;EAjbF;EAobA;IACE,2CAAA;EAlbF;EAqbA;IACE,0BAAA;EAnbF;AACF;AAsbA;EACE;IACE,gDAAA;EApbF;EAubA;IACE,sBAAA;IACA,oBAAA;EArbF;EAwbA;IACE,WAAA;EAtbF;EAybA;IACE,kBAAA;EAvbF;AACF;AA0bA;EACE;IACE,aAAA;EAxbF;EA2bA;IACE,uBAAA;EAzbF;EA4bA;IACE,WAAA;IACA,YAAA;IAEA,mBAAA;IAEA,eAAA;EA5bF;EA+bA;IACE,0BAAA;EA7bF;EAgcA;IACE,iBAAA;EA9bF;EAicA;IACE,0BAAA;EA/bF;EAkcA;IACE,UAAA;EAhcF;EAmcA;IACE,0BAAA;EAjcF;EAocA;IACE,gDAAA;EAlcF;EAqcA;IACE,aAAA;EAncF;EAscA;IACE,uBAAA;EApcF;AACF;AA2cA;;2DAAA;AAIA;EACE,kBAAA;EAEA,WAAA;EACA,eAAA;EACA,YAAA;EAEA,gBAAA;EAEA,sBAAA;AA7cF;;AAidA;;2DAAA;AAIA;EACE,kBAAA;EAEA,aAAA;EAEA,uDACE;EAGF,mBAAA;EAEA,SAAA;EAEA,WAAA;EACA,eAAA;EACA,YAAA;EAEA,gBAAA;EAEA,sBAAA;AAxdF;;AA4dA;;2DAAA;AAIA;EACE,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,WAAA;EACA,eAAA;EACA,YAAA;EAEA,iBAAA;EAEA,gBAAA;EAEA,kBAAA;AA/dF;AAkeE;EACE,kBAAA;EAEA,UAAA;EAEA,0BAAA;AAleJ;AAseE;EACE,0BAAA;AApeJ;AAweE;EACE,eAAA;AAteJ;AA0eE;EACE,eAAA;EAEA,iDACE;AA1eN;;AAgfA;;2DAAA;AAIA;EACE,kBAAA;EAEA,UAAA;EAEA,YAAA;EACA,aAAA;EAEA,kBAAA;EAEA,YAAA;EAEA,kBAAA;EAEA,oBAAA;EAEA,8EACE;EAIF,+CACE;AA1fJ;;AAigBA;EAEE;IAEE,aAAA;IAEA,qBACE;EAlgBJ;EAsgBA;IACE,aAAA;IAEA,sBACE;EAtgBJ;AACF;AA2gBA;;2DAAA;AAIA;EACE,kBAAA;EAEA,WAAA;EAEA,QAAA;EACA,SAAA;EAEA,gCACE;EAEF,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,YAAA;EACA,aAAA;EAEA,YAAA;EAEA,kBAAA;EAEA,oBAAA;EAEA,sBAAA;EAEA,kEACE;EAKF;;6CAAA;EAsCA;;6CAAA;EA0BA;;6CAAA;EA0BA;;6CAAA;AAzmBF;AAmhBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,QAAA;EAEA,eAAA;EAEA,kBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,cAAA;EAEA,sBAAA;EAEA,yBAAA;EAEA,mBAAA;EAEA,2BACE;AA3hBN;AA8hBI;EACE,gBAAA;EAEA,uBAAA;AA7hBN;AAsiBE;EACE,qBAAA;EAEA,UAAA;EACA,WAAA;EAEA,aAAA;EAEA,kBAAA;EAEA,4DACE;EAGF,yDACE;AA5iBN;AAujBE;EACE,cAAA;EAEA,aAAA;EAEA,eAAA;EACA,gBAAA;EAEA,cAAA;EAEA,sBAAA;EAEA,2BACE;EAEF,kEACE;AA7jBN;AAukBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,QAAA;EAEA,eAAA;AAvkBJ;AA0kBI;EACE,gBACE;EAGF,oBAAA;EAEA,mBACE;EAEF,cACE;EAEF,cAAA;EACA,gBAAA;EAEA,cAAA;EAEA,mBAAA;AAllBN;AAslBI;EACE,cACE;EAEF,cAAA;EACA,gBAAA;EAEA,cAAA;EAEA,mBAAA;AAxlBN;;AA8lBA;;2DAAA;AAIA;EAEE;IACE,UAAA;IAEA,4CACE;EA/lBJ;EAomBA;IACE,UAAA;IAEA,4CACE;EApmBJ;EAymBA;IACE,UAAA;IAEA,yCACE;EAzmBJ;AACF;AA+mBA;EAEE;IACE,UAAA;IAEA,qCACE;EAhnBJ;EAqnBA;IACE,UAAA;IAEA,iCACE;EArnBJ;AACF;AA2nBA;EAEE;IAEE,qBACE;EA5nBJ;EAgoBA;IACE,sBACE;EA/nBJ;AACF;AAooBA;;2DAAA;AAIA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EAEA,gBAAA;EAEA,sBAAA;AAroBF;AAwoBE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EAEA,QAAA;EAEA,WAAA;EACA,YAAA;EAEA,mBAAA;AAzoBJ;AA6oBE;EACE,YAAA;AA3oBJ;AA+oBE;EACE,cAAA;EAEA,cACE;EAEF,eAAA;EACA,gBAAA;EAEA,sBAAA;EAEA,yBAAA;EAEA,mBAAA;AAnpBJ;AAupBE;EACE,aAAA;EACA,qBAAA;EACA,eAAA;EAEA,QAAA;EAEA,eACE;EAIF,cACE;EAEF,eAAA;EACA,gBAAA;EAEA,gBAAA;EAEA,sBAAA;AA/pBJ;AAkqBI;EACE,cACE;EAEF,eAAA;EACA,gBAAA;EAEA,iBAAA;EAEA,mBAAA;AApqBN;;AA0qBA;;2DAAA;AAIA;EACE,kBAAA;EAEA,oBAAA;EACA,mBAAA;EAEA,QAAA;EAEA,cAAA;EAEA,gBAAA;EAEA,gBACE;EAGF,yBACE;EAGF,oBAAA;EAEA,mBACE;EAEF,cACE;EAEF,oBAAA;EAEA,cAAA;EACA,gBAAA;EAEA,mBAAA;EAEA,eAAA;EAEA,0HACE;AA7rBJ;AAosBE;EACE,qBACE;EAEF,2BACE;EAEF,6CACE;AAvsBN;AA8sBE;EACE,kBAAA;EAEA,UAAA;EACA,WAAA;EAEA,aAAA;EAEA,kBAAA;EAEA,mBACE;AAjtBN;AAqtBE;EACE,cACE;EAEF,qBACE;EAEF,mBACE;EACF,eAAA;EACA,gBAAA;AAxtBJ;AA2tBI;EACE,mBACE;AA1tBR;AA6tBM;EACE,kBAAA;EAEA,WAAA;EAEA,WAAA;EAEA,wCACE;EAGF,kBAAA;EAEA,8CACE;AAnuBV;AA4uBE;EACE,cACE;EAEF,qBACE;EAEF,mBACE;EACF,gBAAA;AA/uBJ;;AAovBA;EAEE;IACE,UAAA;IAEA,qBACE;EApvBJ;EAwvBA;IACE,UAAA;IAEA,qBACE;EAxvBJ;AACF;AA6vBA;;2DAAA;AAIA;EACE,aAAA;EACA,sBAAA;EAEA,QAAA;EAEA,WAAA;EACA,eAAA;EACA,YAAA;EAGA;;6CAAA;EAqIA;;6CAAA;EAqBA;;6CAAA;EA2CA;;6CAAA;EA8CA;;6CAAA;EA0BA;;6CAAA;AA5/BF;AAmvBE;EACE,kBAAA;EAEA,cAAA;EAEA,WAAA;EACA,eAAA;EACA,YAAA;EAEA,sBACE;EAIF,gBAAA;EAEA,yBACE;EAGF,mBAAA;EAEA,mBACE;EAEF,cAAA;EAEA,gBAAA;EAEA,oBAAA;EAEA,eAAA;EAEA,sBAAA;EAEA,wBACE;EAEF,6GACE;AAvwBN;AA6wBI;EACE,kBAAA;EAEA,MAAA;EACA,OAAA;EAEA,UAAA;EACA,YAAA;EAEA,WAAA;EAEA,+BACE;EAEF,UAAA;EAEA,sBACE;EAEF,oDACE;AArxBR;AA0xBI;EACE,iCACE;EAEF,6CACE;AA3xBR;AAkyBI;EACE,iCACE;EAEF,yFACE;EAMF,gFACE;AAzyBR;AAozBM;EACE,UAAA;EAEA,oBACE;AApzBV;AAwzBM;EACE,+BACE;EAEF,sBACE;AAzzBV;AA6zBM;EACE,UAAA;AA3zBR;AAq0BE;EACE,aAAA;EAEA,+CACE;EAIF,mBAAA;EAEA,QAAA;EAEA,WAAA;EACA,YAAA;AA10BJ;AAk1BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,WAAA;EACA,YAAA;EAEA,cAAA;EAEA,kBAAA;EAEA,mBACE;EAEF,6DACE;AAv1BN;AA41BE;EACE,UAAA;EACA,WAAA;EAEA,kBAAA;EAEA,+BACE;EAEF,yCACE;AA/1BN;AA22BE;EACE,aAAA;EACA,mBAAA;EAEA,QAAA;EAEA,YAAA;AA32BJ;AA82BI;EACE,YAAA;EAEA,gBAAA;EAEA,cACE;EAEF,eAAA;EACA,gBAAA;EAEA,mBAAA;EAEA,uBAAA;AAl3BN;AAs3BI;EACE,cAAA;EAEA,cACE;EAEF,eAAA;EACA,gBAAA;EAEA,cAAA;EAEA,sBAAA;AAz3BN;AAk4BE;EACE,cAAA;EAEA,gBACE;EAGF,oBAAA;EAEA,+BACE;EAEF,0BACE;EAEF,eAAA;EACA,gBAAA;EAEA,mBAAA;AA14BJ;AAk5BE;EACE,WAAA;EAEA,eAAA;EACA,iBAAA;EAEA,gBAAA;EAEA,oBAAA;EAEA,mBACE;AAr5BN;AAw5BI;EACE,cAAA;EAEA,YAAA;EAEA,sBAAA;EAEA,+BACE;EAEF,YAAA;EAEA,wEACE;AA75BR;;AAw6BA;;2DAAA;AAIA;EACE,gBAAA;EAEA,kBACE;EAGF,mBAAA;EAEA,mBACE;EAEF,8CACE;AA96BJ;AAo7BE;EACE,aAAA;EACA,mBAAA;EAEA,QAAA;EAEA,kBAAA;EAEA,cACE;EAEF,eAAA;AAv7BJ;AA27BE;EACE,UAAA;EACA,WAAA;EAEA,aAAA;EAEA,kBAAA;AA37BJ;AA+7BE;EACE,aAAA;EACA,qBAAA;EAEA,QAAA;AA97BJ;AAi8BI;EACE,cACE;EAEF,eAAA;EACA,gBAAA;AAj8BN;AAq8BI;EACE,cACE;EAEF,eAAA;EACA,gBAAA;AAr8BN;AA08BE;EACE,eAAA;EAEA,cACE;EAEF,cAAA;EACA,gBAAA;AA38BJ;;AAg9BA;;2DAAA;AAIA;EAEE;IACE,uDACE;IAGF,QAAA;EAl9BF;EAw9BE;IACE,eAAA;EAt9BJ;AACF;AA69BA;;2DAAA;AAIA;EAEE;IACE,uDACE;IAGF,QAAA;EAh+BF;EAo+BA;IACE,iBAAA;EAl+BF;EAs+BA;IACE,WAAA;IACA,YAAA;EAp+BF;EAu+BE;IACE,QAAA;IAEA,cAAA;EAt+BJ;EA0+BE;IACE,eAAA;EAx+BJ;EA8+BI;IACE,cAAA;EA5+BN;EAg/BI;IACE,cAAA;EA9+BN;EAu/BE;IACE,mBAAA;EAr/BJ;EAy/BE;IACE,eAAA;EAv/BJ;EA0/BI;IACE,cAAA;EAx/BN;EA8/BA;IACE,QAAA;EA5/BF;EA+/BE;IACE,oBACE;EA9/BN;EAogCE;IACE,+CACE;IAIF,QAAA;EAtgCJ;EA0gCE;IACE,WAAA;IACA,YAAA;IAEA,gBAAA;EAzgCJ;EA+gCI;IACE,cAAA;EA7gCN;EAihCI;IACE,eAAA;EA/gCN;EAqhCE;IACE,gBACE;IAGF,cAAA;EAthCJ;EA0hCE;IACE,iBAAA;EAxhCJ;AACF;AA+hCA;;2DAAA;AAIA;EAEE;IACE,0BAAA;IAEA,QAAA;EAhiCF;EAoiCA;IACE,iBAAA;EAliCF;EAsiCA;IACE,WAAA;IACA,eAAA;EApiCF;AACF;AAyiCA;;2DAAA;AAIA;EAEE;IACE,iBAAA;EAziCF;EA6iCA;IACE,WAAA;IACA,YAAA;EA3iCF;EA8iCE;IACE,cAAA;EA5iCJ;EAgjCE;IACE,eAAA;EA9iCJ;EAojCI;IACE,aAAA;EAljCN;EA2jCE;IACE,mBAAA;EAzjCJ;EA6jCE;IACE,eAAA;EA3jCJ;EAmkCE;IACE,YAAA;EAjkCJ;EAqkCE;IACE,+CACE;EApkCN;EA0kCE;IACE,WAAA;IACA,YAAA;EAxkCJ;AACF","sourcesContent":["// MachineUtilizationDashboard/MachineUtilizationDashboard.scss\n\n$primary: #053c83;\n$secondary: #2f539d;\n\n$success: #16a34a;\n$warning: #f59e0b;\n$danger: #ef4444;\n$purple: #7c3aed;\n$cyan: #0891b2;\n\n$text-primary: #0f172a;\n$text-secondary: #475569;\n$text-muted: #64748b;\n\n$border: #e7edf5;\n$surface: #ffffff;\n$background: #f5f8fc;\n\n.machine-utilization-dashboard {\n  --mud-primary: #053c83;\n  --mud-secondary: #2f539d;\n  --mud-success: #16a34a;\n  --mud-warning: #f59e0b;\n  --mud-danger: #ef4444;\n\n  position: relative;\n  width: 100%;\n  padding: 0 0 28px;\n  color: $text-primary;\n\n  * {\n    box-sizing: border-box;\n  }\n}\n\n/* ============================================================\n   HERO\n============================================================ */\n\n.mud-hero {\n  position: relative;\n  overflow: hidden;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n\n  min-height: 150px;\n  margin-bottom: 18px;\n  padding: 24px 28px;\n\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 20px;\n\n  background:\n    radial-gradient(circle at 82% 10%,\n      rgba(77, 129, 220, 0.5),\n      transparent 29%),\n    radial-gradient(circle at 20% 120%,\n      rgba(59, 130, 246, 0.33),\n      transparent 32%),\n    linear-gradient(135deg, #032f69 0%, #053c83 47%, #2f539d 100%);\n\n  box-shadow:\n    0 22px 55px rgba(5, 60, 131, 0.18),\n    inset 0 1px 0 rgba(255, 255, 255, 0.12);\n\n  &::before {\n    content: \"\";\n\n    position: absolute;\n    right: -90px;\n    top: -120px;\n\n    width: 310px;\n    height: 310px;\n\n    border: 55px solid rgba(255, 255, 255, 0.045);\n    border-radius: 50%;\n  }\n\n  &::after {\n    content: \"\";\n\n    position: absolute;\n    left: 36%;\n    bottom: -125px;\n\n    width: 280px;\n    height: 280px;\n\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 50%;\n  }\n}\n\n.mud-hero__content {\n  position: relative;\n  z-index: 2;\n\n  display: flex;\n  align-items: center;\n  gap: 18px;\n\n  max-width: 780px;\n\n  h2 {\n    margin: 3px 0 6px;\n\n    color: #ffffff;\n    font-size: clamp(22px, 2vw, 31px);\n    line-height: 1.18;\n    font-weight: 650;\n    letter-spacing: -0.7px;\n  }\n\n  p {\n    max-width: 720px;\n    margin: 0;\n\n    color: rgba(255, 255, 255, 0.73);\n    font-size: 12px;\n    line-height: 1.65;\n  }\n}\n\n.mud-hero__icon {\n  flex: 0 0 auto;\n\n  display: grid;\n  place-items: center;\n\n  width: 62px;\n  height: 62px;\n\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 18px;\n\n  color: #ffffff;\n  font-size: 28px;\n\n  background: rgba(255, 255, 255, 0.12);\n  backdrop-filter: blur(12px);\n\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.17);\n}\n\n.mud-hero__eyebrow {\n  color: #bfdbfe;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 1.5px;\n}\n\n.mud-hero__meta {\n  position: relative;\n  z-index: 2;\n\n  display: grid;\n  grid-template-columns: repeat(2, minmax(120px, 1fr));\n  gap: 8px;\n\n  min-width: 330px;\n\n  >div {\n    padding: 11px 13px;\n\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 12px;\n\n    background: rgba(255, 255, 255, 0.08);\n    backdrop-filter: blur(10px);\n\n    span {\n      display: block;\n\n      margin-bottom: 3px;\n\n      color: rgba(255, 255, 255, 0.58);\n      font-size: 10px;\n      font-weight: 600;\n      text-transform: uppercase;\n      letter-spacing: 0.7px;\n    }\n\n    strong {\n      color: #ffffff;\n      font-size: 14px;\n      font-weight: 700;\n    }\n  }\n}\n\n.mud-hero__live {\n  grid-column: 1 / -1;\n\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n\n  color: #dcfce7 !important;\n}\n\n.mud-live-dot {\n  display: inline-block !important;\n\n  width: 8px;\n  height: 8px;\n  margin: 0 !important;\n\n  border-radius: 50%;\n  background: #4ade80;\n\n  box-shadow: 0 0 0 5px rgba(74, 222, 128, 0.12);\n\n  animation: mudLivePulse 1.8s infinite;\n}\n\n@keyframes mudLivePulse {\n\n  0%,\n  100% {\n    box-shadow: 0 0 0 4px rgba(74, 222, 128, 0.12);\n  }\n\n  50% {\n    box-shadow: 0 0 0 8px rgba(74, 222, 128, 0.03);\n  }\n}\n\n/* ============================================================\n   KPI CARDS\n============================================================ */\n\n.mud-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 12px;\n\n  margin-bottom: 16px;\n}\n\n.mud-kpi-card {\n  position: relative;\n  overflow: hidden;\n\n  min-height: 132px;\n  padding: 16px;\n\n  border: 1px solid $border;\n  border-radius: 16px;\n\n  background: $surface;\n\n  box-shadow:\n    0 6px 24px rgba(15, 23, 42, 0.045),\n    0 1px 2px rgba(15, 23, 42, 0.03);\n\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease,\n    border-color 0.2s ease;\n\n  &:hover {\n    transform: translateY(-3px);\n\n    border-color: rgba(5, 60, 131, 0.15);\n\n    box-shadow:\n      0 16px 32px rgba(15, 23, 42, 0.075),\n      0 2px 4px rgba(15, 23, 42, 0.035);\n  }\n}\n\n.mud-kpi-card__glow {\n  position: absolute;\n  right: -30px;\n  top: -30px;\n\n  width: 100px;\n  height: 100px;\n\n  border-radius: 50%;\n  opacity: 0.08;\n}\n\n.mud-kpi-card__top {\n  position: relative;\n  z-index: 1;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.mud-kpi-card__icon {\n  display: grid;\n  place-items: center;\n\n  width: 37px;\n  height: 37px;\n\n  border-radius: 10px;\n\n  font-size: 16px;\n}\n\n.mud-kpi-card__label {\n  display: block;\n  // margin-bottom: 2px;\n  // color: $text-muted;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n\n.mud-kpi-card__pulse {\n  width: 6px;\n  height: 6px;\n\n  border-radius: 50%;\n}\n\n.mud-kpi-card__content {\n  position: relative;\n  z-index: 1;\n\n  margin-top: 12px;\n\n\n  .mud-kpi-card__value {\n    display: block;\n\n    color: $text-primary;\n    font-size: 26px;\n    line-height: 1.15;\n    font-weight: 700;\n    letter-spacing: -0.6px;\n  }\n\n  small {\n    display: block;\n\n    margin-top: 4px;\n\n    color: #94a3b8;\n    font-size: 14px;\n  }\n}\n\n@mixin kpi-tone($color, $light) {\n  .mud-kpi-card__icon {\n    color: $color;\n    background: $light;\n  }\n\n  .mud-kpi-card__glow {\n    background: $color;\n  }\n\n  .mud-kpi-card__pulse {\n    background: $color;\n    box-shadow: 0 0 0 4px rgba($color, 0.1);\n  }\n}\n\n.mud-kpi-card--primary {\n  @include kpi-tone($primary, #eaf2ff);\n}\n\n.mud-kpi-card--success {\n  @include kpi-tone($success, #ecfdf3);\n}\n\n.mud-kpi-card--warning {\n  @include kpi-tone($warning, #fffbeb);\n}\n\n.mud-kpi-card--danger {\n  @include kpi-tone($danger, #fff1f2);\n}\n\n.mud-kpi-card--purple {\n  @include kpi-tone($purple, #f5f3ff);\n}\n\n/* ============================================================\n   SECTION CONTAINER\n============================================================ */\n\n.mud-section {\n  min-width: 0;\n  margin-bottom: 0px;\n\n  border: 1px solid $border;\n  border-radius: 18px;\n\n  background: $surface;\n\n  box-shadow:\n    0 7px 26px rgba(15, 23, 42, 0.045),\n    0 1px 2px rgba(15, 23, 42, 0.02);\n}\n\n.mud-section__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n\n  padding: 17px 19px 13px;\n\n  border-bottom: 1px solid #edf2f7;\n\n  h3 {\n    margin: 2px 0 3px;\n\n    color: $text-primary;\n    font-size: 20px;\n    font-weight: 640;\n    letter-spacing: -0.15px;\n  }\n\n  p {\n    margin: 0;\n\n    color: $text-muted;\n    font-size: 12px;\n    line-height: 1.5;\n  }\n}\n\n.mud-section__eyebrow {\n  display: inline-block;\n\n  color: $secondary;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1.0px;\n}\n\n.mud-section__body {\n  min-width: 0;\n  padding: 19px 19px 19px;\n}\n\n.mud-overview-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.6fr) minmax(310px, 0.7fr);\n  gap: 16px;\n\n  >.mud-section {\n    margin-bottom: 0;\n  }\n\n  margin-bottom: 16px;\n}\n\n.mud-two-column-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n\n  >.mud-section {\n    margin-bottom: 0;\n  }\n\n  margin-bottom: 16px;\n}\n\n/* ============================================================\n   OVERALL UTILIZATION\n============================================================ */\n\n.mud-overall-card {\n  display: grid;\n  grid-template-columns: 270px minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n}\n\n.mud-overall-card__chart {\n  min-width: 0;\n}\n\n.mud-overall-card__details {\n  padding: 5px 6px 5px 16px;\n}\n\n.mud-overall-card__headline {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n\n  margin-bottom: 16px;\n\n  span {\n    color: $text-muted;\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  h4 {\n    margin: 2px 0 0;\n\n    color: $primary;\n    font-size: 31px;\n    line-height: 1;\n    font-weight: 850;\n    letter-spacing: -1px;\n  }\n}\n\n.mud-performance-badge {\n  display: inline-flex;\n  align-items: center;\n\n  padding: 2px 10px;\n\n  border-radius: 999px;\n\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  white-space: nowrap;\n\n  &--success {\n    color: #15803d !important;\n    background: #dcfce7;\n  }\n\n  &--warning {\n    color: #b45309 !important;\n    background: #fef3c7;\n  }\n\n  &--danger {\n    color: #b91c1c !important;\n    background: #fee2e2;\n  }\n\n  &--purple {\n    color: #6d28d9 !important;\n    background: #ede9fe;\n  }\n\n  &--neutral {\n    color: #475569 !important;\n    background: #f1f5f9;\n  }\n}\n\n.mud-overall-stats {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n\n  >div {\n    padding: 10px 11px;\n\n    border: 1px solid #edf2f7;\n    border-radius: 10px;\n\n    background: #fafcff;\n\n    span {\n      display: block;\n\n      margin-bottom: 3px;\n\n      color: $text-muted;\n      font-size: 12px;\n    }\n\n    strong {\n      color: $text-primary;\n      font-size: 16px;\n      font-weight: 640;\n    }\n  }\n}\n\n.mud-runtime-progress {\n  margin-top: 14px;\n}\n\n.mud-runtime-progress__header {\n  display: flex;\n  justify-content: space-between;\n\n  margin-bottom: 6px;\n\n  span {\n    color: $text-muted;\n    font-size: 12px;\n  }\n\n  strong {\n    color: $primary;\n    font-size: 10px;\n  }\n}\n\n.mud-runtime-progress__track,\n.mud-mini-progress {\n  overflow: hidden;\n\n  width: 100%;\n  height: 6px;\n\n  border-radius: 999px;\n  background: #e8eef7;\n\n  span {\n    display: block;\n\n    height: 100%;\n\n    border-radius: inherit;\n\n    background: linear-gradient(90deg, $primary, #3b82f6);\n  }\n}\n\n/* ============================================================\n   STATUS DONUT\n============================================================ */\n\n.mud-donut-layout {\n  display: flex;\n  flex-direction: column;\n}\n\n.mud-status-legend {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 7px;\n}\n\n.mud-status-legend__item {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n\n  padding: 8px;\n\n  border: 1px solid #edf2f7;\n  border-radius: 9px;\n\n  background: #fafcff;\n\n  >span {\n    flex: 0 0 auto;\n\n    width: 7px;\n    height: 7px;\n\n    border-radius: 50%;\n\n    &.running {\n      background: $success;\n    }\n\n    &.idle {\n      background: $warning;\n    }\n\n    &.stopped {\n      background: $danger;\n    }\n  }\n\n  small {\n    display: block;\n\n    color: $text-muted;\n    font-size: 12px;\n  }\n\n  strong {\n    display: block;\n\n    margin-top: 1px;\n\n    color: $text-primary;\n    font-size: 16px;\n  }\n}\n\n/* ============================================================\n   RANKING\n============================================================ */\n\n.mud-ranking-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.mud-ranking-chart {\n  min-width: 0;\n  padding: 13px;\n\n  border: 1px solid #edf2f7;\n  border-radius: 14px;\n\n  background: #fbfdff;\n}\n\n.mud-ranking-chart__title {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n\n  margin-bottom: 6px;\n\n  h4 {\n    margin: 0;\n\n    color: $text-primary;\n    font-size: 15px;\n    font-weight: 640;\n  }\n\n  p {\n    margin: 2px 0 0;\n\n    color: $text-muted;\n    font-size: 8px;\n  }\n}\n\n.mud-ranking-icon {\n  display: grid;\n  place-items: center;\n\n  width: 32px;\n  height: 32px;\n\n  border-radius: 9px;\n\n  &--top {\n    color: $primary;\n    background: #eaf2ff;\n  }\n\n  &--bottom {\n    color: $danger;\n    background: #fff1f2;\n  }\n}\n\n/* ============================================================\n   CHART TOOLTIP\n============================================================ */\n\n.mud-chart-tooltip {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n\n  min-width: 160px;\n  padding: 10px 12px;\n\n  strong {\n    color: $text-primary;\n    font-size: 14px;\n  }\n\n  span {\n    color: $text-muted;\n    font-size: 12px;\n  }\n\n  b {\n    margin-top: 3px;\n\n    color: $primary;\n    font-size: 14px;\n  }\n}\n\n/* ============================================================\n   HEAT MAP\n============================================================ */\n\n.mud-heatmap__legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n\n  margin-bottom: 12px;\n\n  span {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n\n    color: $text-muted;\n    font-size: 14px;\n\n    i {\n      width: 9px;\n      height: 9px;\n\n      border-radius: 3px;\n\n      &.high {\n        background: #16a34a;\n      }\n\n      &.medium {\n        background: #f59e0b;\n      }\n\n      &.low {\n        background: #ef4444;\n      }\n\n      &.no-data {\n        background: #e2e8f0;\n      }\n    }\n  }\n}\n\n.mud-heatmap__scroll {\n  overflow-x: auto;\n\n  padding-bottom: 5px;\n\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.mud-heatmap__grid {\n  display: grid;\n\n  min-width: 1080px;\n\n  border: 1px solid #e8eef6;\n  border-radius: 12px;\n\n  background: #ffffff;\n}\n\n.mud-heatmap__corner,\n.mud-heatmap__hour {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  min-height: 35px;\n\n  border-bottom: 1px solid #e8eef6;\n\n  color: $text-muted;\n  font-size: 12px;\n  font-weight: 640;\n\n  background: #f8fafc;\n}\n\n.mud-heatmap__corner {\n  justify-content: flex-start;\n\n  padding-left: 12px;\n\n  border-right: 1px solid #e8eef6;\n}\n\n.mud-heatmap__row {\n  display: grid;\n\n  min-height: 43px;\n\n  border-bottom: 1px solid #edf2f7;\n\n  &:last-child {\n    border-bottom: 0;\n  }\n}\n\n.mud-heatmap__machine {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  padding: 5px 10px;\n\n  border-right: 1px solid #edf2f7;\n\n  strong {\n    color: $text-primary;\n    font-size: 12px;\n  }\n\n  span {\n    overflow: hidden;\n\n    max-width: 125px;\n\n    color: $text-muted;\n    font-size: 7px;\n\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.mud-heatmap__cell {\n  display: grid;\n  place-items: center;\n\n  margin: 4px 3px;\n\n  border-radius: 5px;\n\n  color: rgba(255, 255, 255, 0.92);\n  font-size: 12px;\n  font-weight: 700;\n\n  cursor: help;\n\n  transition:\n    transform 0.15s ease,\n    filter 0.15s ease;\n\n  &:hover {\n    transform: scale(1.12);\n    filter: brightness(0.95);\n  }\n\n  &.high {\n    background: #16a34a;\n  }\n\n  &.medium {\n    background: #f59e0b;\n  }\n\n  &.low {\n    background: #ef4444;\n  }\n\n  &.no-data {\n    background: #edf2f7;\n  }\n}\n\n/* ============================================================\n   LIVE MACHINE TOOLBAR\n============================================================ */\n\n.mud-live-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n\n  margin-bottom: 14px;\n}\n\n.mud-search {\n  position: relative;\n\n  width: min(360px, 100%);\n\n  i {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n\n    transform: translateY(-50%);\n\n    color: #94a3b8;\n    font-size: 11px;\n  }\n\n  input {\n    width: 100%;\n    height: 35px;\n\n    padding: 0 13px 0 34px;\n\n    border: 1px solid #dce5ef;\n    border-radius: 9px;\n    outline: none;\n\n    color: $text-primary;\n    font-size: 10px;\n\n    background: #fafcff;\n\n    transition:\n      border-color 0.2s ease,\n      box-shadow 0.2s ease;\n\n    &:focus {\n      border-color: rgba(5, 60, 131, 0.45);\n\n      box-shadow: 0 0 0 3px rgba(5, 60, 131, 0.07);\n    }\n\n    &::placeholder {\n      color: #94a3b8;\n    }\n  }\n}\n\n.mud-filter-tabs,\n.mud-alert-filter {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  padding: 3px;\n\n  border: 1px solid #e7edf5;\n  border-radius: 9px;\n\n  background: #f8fafc;\n\n  button {\n    padding: 6px 9px;\n\n    border: 0;\n    border-radius: 6px;\n\n    color: $text-muted;\n    font-size: 10px;\n    font-weight: 750;\n\n    background: transparent;\n\n    cursor: pointer;\n\n    transition:\n      color 0.15s ease,\n      background 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &.active {\n      color: #ffffff;\n      background: $primary;\n\n      box-shadow: 0 3px 8px rgba(5, 60, 131, 0.18);\n    }\n  }\n}\n\n/* ============================================================\n   MACHINE CARDS\n============================================================ */\n\n.mud-machine-card-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 11px;\n}\n\n.mud-machine-card {\n  position: relative;\n  overflow: hidden;\n\n  padding: 13px;\n\n  border: 1px solid #d5d5d5;\n  border-radius: 13px;\n\n  background: #fffbfb;\n\n  box-shadow: 0 4px 15px rgba(15, 23, 42, 0.035);\n\n  transition:\n    transform 0.18s ease,\n    box-shadow 0.18s ease;\n\n  &::before {\n    content: \"\";\n\n    position: absolute;\n    left: 0;\n    top: 0;\n\n    width: 3px;\n    height: 100%;\n  }\n\n  &--running::before {\n    background: $success;\n  }\n\n  &--idle::before {\n    background: $warning;\n  }\n\n  &--stopped::before {\n    background: $danger;\n  }\n\n  &:hover {\n    transform: translateY(-3px);\n\n    box-shadow: 0 12px 25px rgba(15, 23, 42, 0.075);\n  }\n}\n\n.mud-machine-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 7px;\n}\n\n.mud-machine-card__machine {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n\n  min-width: 0;\n\n  >div {\n    min-width: 0;\n  }\n\n  strong,\n  small {\n    display: block;\n  }\n\n  strong {\n    color: $text-primary;\n    font-size: 14px;\n    font-weight: 640;\n  }\n\n  small {\n    overflow: hidden;\n\n    max-width: 130px;\n\n    margin-top: 1px;\n\n    color: $text-muted;\n    font-size: 12px;\n\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.mud-machine-card__icon {\n  flex: 0 0 auto;\n\n  display: grid;\n  place-items: center;\n\n  width: 29px;\n  height: 29px;\n\n  border-radius: 8px;\n\n  color: $primary;\n  font-size: 12px;\n\n  background: #eaf2ff;\n}\n\n.mud-live-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n\n  padding: 2px 12px;\n\n  border-radius: 999px;\n\n  font-size: 12px;\n  font-weight: 700;\n\n  i {\n    width: 5px;\n    height: 5px;\n\n    border-radius: 50%;\n  }\n\n  &.running {\n    color: #15803d;\n    background: #dcfce7;\n\n    i {\n      background: $success;\n    }\n  }\n\n  &.idle {\n    color: #b45309;\n    background: #fef3c7;\n\n    i {\n      background: $warning;\n    }\n  }\n\n  &.stopped {\n    color: #b91c1c;\n    background: #fee2e2;\n\n    i {\n      background: $danger;\n    }\n  }\n}\n\n.mud-machine-card__department {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  margin: 9px 0 10px;\n\n  color: $text-muted;\n  font-size: 14px;\n  font-weight: 600;\n\n  i {\n    color: #94a3b8;\n  }\n}\n\n.mud-machine-card__utilization {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 7px;\n\n  margin-bottom: 6px;\n\n  span {\n    color: $text-muted;\n    font-size: 12px;\n  }\n\n  >div {\n\n    span,\n    strong {\n      display: block;\n    }\n\n    span {\n      color: $text-muted;\n      font-size: 12px;\n    }\n\n    strong {\n      margin-top: 1px;\n\n      color: $text-primary;\n      font-size: 16px;\n      font-weight: 650;\n    }\n  }\n}\n\n.mud-mini-progress {\n  height: 4px;\n}\n\n.mud-machine-card__metrics {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 4px;\n\n  margin-top: 10px;\n\n  >div {\n    padding: 6px 4px;\n\n    border-radius: 7px;\n\n    text-align: center;\n\n    background: #e9e6e6;\n\n    span,\n    strong {\n      display: block;\n    }\n\n    span {\n      color: #94a3b8;\n      font-size: 12px;\n    }\n\n    strong {\n      overflow: hidden;\n\n      margin-top: 2px;\n\n      color: $text-primary;\n      font-size: 14px;\n      font-weight: 750;\n\n      text-overflow: ellipsis;\n      white-space: nowrap;\n\n      &.danger {\n        color: $danger;\n      }\n    }\n  }\n}\n\n.mud-machine-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 7px;\n\n  margin-top: 9px;\n  padding-top: 8px;\n\n  border-top: 1px solid #edf2f7;\n\n  >div {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    min-width: 0;\n\n    color: $text-muted;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 1px;\n\n    i {\n      flex: 0 0 auto;\n    }\n\n    span {\n      overflow: hidden;\n\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n}\n\n.mud-jobcard-badge {\n  flex: 0 0 auto;\n  padding: 3px 12px;\n  border-radius: 5px;\n  color: #053c83;\n  font-size: 12px;\n  font-weight: 700;\n  background: #eef4ff;\n}\n\n.mud-load-more {\n  display: flex;\n  justify-content: center;\n\n  margin-top: 15px;\n\n  button {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n\n    padding: 8px 15px;\n\n    border: 1px solid #d9e3ef;\n    border-radius: 8px;\n\n    color: $primary;\n    font-size: 14px;\n    font-weight: 750;\n\n    background: #ffffff;\n\n    cursor: pointer;\n\n    transition:\n      background 0.15s ease,\n      border-color 0.15s ease;\n\n    &:hover {\n      border-color: rgba($primary, 0.25);\n      background: #f6f9ff;\n    }\n  }\n}\n\n/* ============================================================\n   ALERT PANEL\n============================================================ */\n\n.mud-alert-summary {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n\n  margin-bottom: 10px;\n\n  >div {\n    padding: 10px 12px;\n\n    border: 1px solid #e7edf5;\n    border-radius: 9px;\n\n    background: #fafcff;\n\n    span {\n      display: block;\n\n      color: $text-muted;\n      font-size: 14px;\n      font-weight: 600;\n    }\n\n    strong {\n      display: block;\n\n      margin-top: 2px;\n\n      color: $text-primary;\n      font-size: 17px;\n      font-weight: 850;\n    }\n\n    &.critical {\n      border-color: #fecdd3;\n      background: #fff1f2;\n\n      strong {\n        color: #be123c;\n      }\n    }\n\n    &.warning {\n      border-color: #fde68a;\n      background: #fffbeb;\n\n      strong {\n        color: #b45309;\n      }\n    }\n\n    &.info {\n      border-color: #bae6fd;\n      background: #f0f9ff;\n\n      strong {\n        color: #0369a1;\n      }\n    }\n  }\n}\n\n.mud-alert-filter {\n  width: fit-content;\n  margin-bottom: 10px;\n}\n\n.mud-alert-list {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n\n  max-height: 540px;\n  overflow-y: auto;\n\n  padding-right: 4px;\n\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.mud-alert-item {\n  display: flex;\n  gap: 10px;\n\n  padding: 11px;\n\n  border: 1px solid #e8eef5;\n  border-radius: 10px;\n\n  background: #ffffff;\n\n  &--critical {\n    border-left: 3px solid #e11d48;\n  }\n\n  &--warning {\n    border-left: 3px solid #f59e0b;\n  }\n\n  &--info {\n    border-left: 3px solid #0ea5e9;\n  }\n}\n\n.mud-alert-item__icon {\n  flex: 0 0 auto;\n\n  display: grid;\n  place-items: center;\n\n  width: 30px;\n  height: 30px;\n\n  border-radius: 8px;\n\n  .mud-alert-item--critical & {\n    color: #e11d48;\n    background: #fff1f2;\n  }\n\n  .mud-alert-item--warning & {\n    color: #d97706;\n    background: #fffbeb;\n  }\n\n  .mud-alert-item--info & {\n    color: #0284c7;\n    background: #f0f9ff;\n  }\n}\n\n.mud-alert-item__body {\n  flex: 1;\n  min-width: 0;\n\n  p {\n    margin: 5px 0 7px;\n\n    color: $text-secondary;\n    font-size: 14px;\n    line-height: 1.5;\n  }\n}\n\n.mud-alert-item__heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n\n  strong {\n    display: block;\n\n    color: $text-primary;\n    font-size: 15px;\n    font-weight: 740;\n  }\n\n  span {\n    display: block;\n\n    margin-top: 1px;\n\n    color: $text-muted;\n    font-size: 12px;\n  }\n}\n\n.mud-alert-severity {\n  flex: 0 0 auto;\n\n  padding: 2px 16px;\n\n  border-radius: 999px;\n\n  font-size: 14px !important;\n  font-weight: 720;\n\n  &--critical {\n    color: #be123c !important;\n    background: #ffe4e6;\n  }\n\n  &--warning {\n    color: #b45309 !important;\n    background: #fef3c7;\n  }\n\n  &--info {\n    color: #0369a1 !important;\n    background: #e0f2fe;\n  }\n}\n\n.mud-alert-item__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 5px 12px;\n\n  span {\n    color: $text-muted;\n    font-size: 14px;\n\n    b {\n      color: $text-primary;\n    }\n  }\n}\n\n.mud-alert-machine-status {\n  padding: 2px 5px;\n\n  border-radius: 4px;\n\n  color: $primary !important;\n  font-weight: 700;\n\n  background: #eef4ff;\n}\n\n/* ============================================================\n   EMPTY STATE\n============================================================ */\n\n.mud-empty-state {\n  display: grid;\n  place-items: center;\n\n  min-height: 180px;\n  padding: 24px;\n\n  color: $text-muted;\n  font-size: 10px;\n  text-align: center;\n\n  border: 1px dashed #dce5ef;\n  border-radius: 10px;\n\n  background: #fbfdff;\n}\n\n.mud-no-data {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  min-height: 360px;\n  padding: 30px;\n\n  border: 1px solid $border;\n  border-radius: 18px;\n\n  background: #ffffff;\n\n  span {\n    display: grid;\n    place-items: center;\n\n    width: 60px;\n    height: 60px;\n\n    margin-bottom: 12px;\n\n    border-radius: 18px;\n\n    color: $primary;\n    font-size: 27px;\n\n    background: #eaf2ff;\n  }\n\n  h3 {\n    margin: 0;\n\n    font-size: 17px;\n  }\n\n  p {\n    margin: 5px 0 0;\n\n    color: $text-muted;\n    font-size: 10px;\n  }\n}\n\n/* ============================================================\n   SKELETON\n============================================================ */\n\n.mud-skeleton-dashboard {\n  padding: 5px 0 25px;\n}\n\n@mixin skeleton-background {\n  background: linear-gradient(90deg,\n      #eef2f7 25%,\n      #f8fafc 50%,\n      #eef2f7 75%);\n\n  background-size: 200% 100%;\n\n  animation: mudSkeleton 1.4s infinite;\n}\n\n@keyframes mudSkeleton {\n  from {\n    background-position: 200% 0;\n  }\n\n  to {\n    background-position: -200% 0;\n  }\n}\n\n.mud-skeleton-kpis {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.mud-skeleton-card {\n  height: 130px;\n  padding: 16px;\n\n  border: 1px solid $border;\n  border-radius: 16px;\n\n  background: white;\n\n  span,\n  strong,\n  small {\n    display: block;\n\n    border-radius: 5px;\n\n    @include skeleton-background;\n  }\n\n  span {\n    width: 36px;\n    height: 36px;\n  }\n\n  strong {\n    width: 70%;\n    height: 21px;\n\n    margin-top: 15px;\n  }\n\n  small {\n    width: 45%;\n    height: 8px;\n\n    margin-top: 8px;\n  }\n}\n\n.mud-skeleton-large {\n  height: 350px;\n  margin-top: 16px;\n  padding: 20px;\n\n  border: 1px solid $border;\n  border-radius: 18px;\n\n  background: white;\n\n  span {\n    display: block;\n\n    width: 100%;\n    height: 100%;\n\n    border-radius: 12px;\n\n    @include skeleton-background;\n  }\n}\n\n.mud-skeleton-two {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n\n  margin-top: 16px;\n\n  >div {\n    height: 330px;\n    padding: 20px;\n\n    border: 1px solid $border;\n    border-radius: 18px;\n\n    background: white;\n\n    span {\n      display: block;\n\n      width: 100%;\n      height: 100%;\n\n      border-radius: 12px;\n\n      @include skeleton-background;\n    }\n  }\n}\n\n/* ============================================================\n   APEXCHART OVERRIDES\n============================================================ */\n\n.machine-utilization-dashboard {\n  .apexcharts-tooltip {\n    border: 0 !important;\n    border-radius: 9px !important;\n\n    box-shadow: 0 8px 25px rgba(15, 23, 42, 0.13) !important;\n  }\n\n  .apexcharts-tooltip-title {\n    border-bottom: 1px solid #edf2f7 !important;\n\n    font-family: inherit !important;\n    font-size: 9px !important;\n\n    background: #f8fafc !important;\n  }\n\n  .apexcharts-legend-text,\n  .apexcharts-text {\n    font-family: inherit !important;\n  }\n}\n\n/* ============================================================\n   RESPONSIVE\n============================================================ */\n\n@media (max-width: 1400px) {\n  .mud-kpi-grid {\n    grid-template-columns: repeat(5, minmax(150px, 1fr));\n    overflow-x: auto;\n\n    padding-bottom: 4px;\n  }\n\n  .mud-machine-card-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1150px) {\n  .mud-hero {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .mud-hero__meta {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n\n    min-width: 0;\n  }\n\n  .mud-hero__live {\n    grid-column: auto;\n  }\n\n  .mud-overview-grid,\n  .mud-two-column-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mud-overall-card {\n    grid-template-columns: 240px minmax(0, 1fr);\n  }\n\n  .mud-ranking-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 900px) {\n  .mud-machine-card-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .mud-live-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .mud-search {\n    width: 100%;\n  }\n\n  .mud-filter-tabs {\n    width: fit-content;\n  }\n}\n\n@media (max-width: 700px) {\n  .mud-hero {\n    padding: 19px;\n  }\n\n  .mud-hero__content {\n    align-items: flex-start;\n  }\n\n  .mud-hero__icon {\n    width: 49px;\n    height: 49px;\n\n    border-radius: 13px;\n\n    font-size: 21px;\n  }\n\n  .mud-hero__meta {\n    grid-template-columns: 1fr;\n  }\n\n  .mud-hero__live {\n    grid-column: auto;\n  }\n\n  .mud-overall-card {\n    grid-template-columns: 1fr;\n  }\n\n  .mud-overall-card__details {\n    padding: 0;\n  }\n\n  .mud-machine-card-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mud-alert-summary {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .mud-section__body {\n    padding: 14px;\n  }\n\n  .mud-section__header {\n    padding: 15px 14px 12px;\n  }\n}\n\n\n// MachineUtilizationDashboard.scss\n\n\n/* =========================================================\n   MACHINE STATUS DONUT\n========================================================= */\n\n.mud-machine-status {\n  position: relative;\n\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n\n  overflow: hidden;\n\n  box-sizing: border-box;\n}\n\n\n/* =========================================================\n   MAIN LAYOUT\n========================================================= */\n\n.mud-donut-layout {\n  position: relative;\n\n  display: grid;\n\n  grid-template-columns:\n    minmax(0, 1.35fr)\n    minmax(0, 1fr);\n\n  align-items: center;\n\n  gap: 10px;\n\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n\n  overflow: hidden;\n\n  box-sizing: border-box;\n}\n\n\n/* =========================================================\n   DONUT CHART WRAPPER\n========================================================= */\n\n.mud-donut-chart-wrapper {\n  position: relative;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n\n  min-height: 270px;\n\n  overflow: hidden;\n\n  isolation: isolate;\n\n\n  .apexcharts-canvas {\n    position: relative;\n\n    z-index: 2;\n\n    max-width: 100% !important;\n  }\n\n\n  .apexcharts-svg {\n    max-width: 100% !important;\n  }\n\n\n  .apexcharts-pie {\n    cursor: pointer;\n  }\n\n\n  .apexcharts-pie-area {\n    cursor: pointer;\n\n    transition:\n      opacity 0.25s ease,\n      filter 0.25s ease;\n  }\n}\n\n\n/* =========================================================\n   DONUT BACKGROUND GLOW\n========================================================= */\n\n.mud-donut-glow {\n  position: absolute;\n\n  z-index: 0;\n\n  width: 175px;\n  height: 175px;\n\n  border-radius: 50%;\n\n  opacity: 0.8;\n\n  filter: blur(40px);\n\n  pointer-events: none;\n\n  transition:\n    background-color 0.5s ease,\n    opacity 0.6s ease,\n    transform 0.5s ease;\n\n  animation:\n    mudDonutGlow\n    3s\n    ease-in-out\n    infinite;\n}\n\n\n@keyframes mudDonutGlow {\n\n  0%,\n  100% {\n    opacity: 0.06;\n\n    transform:\n      scale(0.9);\n  }\n\n\n  50% {\n    opacity: 0.15;\n\n    transform:\n      scale(1.15);\n  }\n\n}\n\n\n/* =========================================================\n   CUSTOM DONUT CENTER CONTENT\n========================================================= */\n\n.mud-donut-center-content {\n  position: absolute;\n\n  z-index: 10;\n\n  top: 50%;\n  left: 50%;\n\n  transform:\n    translate(-50%, -50%);\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  width: 105px;\n  height: 105px;\n\n  padding: 4px;\n\n  text-align: center;\n\n  pointer-events: none;\n\n  box-sizing: border-box;\n\n  animation:\n    mudDonutCenterEnter\n    0.55s\n    cubic-bezier(0.16, 1, 0.3, 1);\n\n\n  /* -----------------------------------------\n     STATUS NAME\n  ----------------------------------------- */\n\n  &__status {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    gap: 6px;\n\n    max-width: 100%;\n\n    margin-bottom: 5px;\n\n    font-size: 10px;\n    font-weight: 800;\n\n    line-height: 1;\n\n    letter-spacing: 0.45px;\n\n    text-transform: uppercase;\n\n    white-space: nowrap;\n\n    transition:\n      color 0.4s ease;\n\n\n    > span:last-child {\n      overflow: hidden;\n\n      text-overflow: ellipsis;\n    }\n  }\n\n\n  /* -----------------------------------------\n     STATUS DOT\n  ----------------------------------------- */\n\n  &__dot {\n    display: inline-block;\n\n    width: 6px;\n    height: 6px;\n\n    flex: 0 0 6px;\n\n    border-radius: 50%;\n\n    transition:\n      background-color 0.4s ease,\n      box-shadow 0.4s ease;\n\n    animation:\n      mudCenterStatusPulse\n      1.8s\n      ease-in-out\n      infinite;\n  }\n\n\n  /* -----------------------------------------\n     MACHINE COUNT\n  ----------------------------------------- */\n\n  &__value {\n    display: block;\n\n    margin: 1px 0;\n\n    font-size: 31px;\n    font-weight: 850;\n\n    line-height: 1;\n\n    letter-spacing: -1.3px;\n\n    transition:\n      color 0.4s ease;\n\n    animation:\n      mudCenterValueEnter\n      0.55s\n      cubic-bezier(0.16, 1, 0.3, 1);\n  }\n\n\n  /* -----------------------------------------\n     PERCENTAGE\n  ----------------------------------------- */\n\n  &__percentage {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    gap: 4px;\n\n    margin-top: 6px;\n\n\n    span {\n      padding:\n        3px\n        6px;\n\n      border-radius: 999px;\n\n      background:\n        #f1f5f9;\n\n      color:\n        #475569;\n\n      font-size: 9px;\n      font-weight: 800;\n\n      line-height: 1;\n\n      white-space: nowrap;\n    }\n\n\n    small {\n      color:\n        #94a3b8;\n\n      font-size: 8px;\n      font-weight: 600;\n\n      line-height: 1;\n\n      white-space: nowrap;\n    }\n  }\n}\n\n\n/* =========================================================\n   CENTER CONTENT ENTER ANIMATION\n========================================================= */\n\n@keyframes mudDonutCenterEnter {\n\n  0% {\n    opacity: 0;\n\n    transform:\n      translate(-50%, -43%)\n      scale(0.82);\n  }\n\n\n  65% {\n    opacity: 1;\n\n    transform:\n      translate(-50%, -51%)\n      scale(1.04);\n  }\n\n\n  100% {\n    opacity: 1;\n\n    transform:\n      translate(-50%, -50%)\n      scale(1);\n  }\n\n}\n\n\n@keyframes mudCenterValueEnter {\n\n  0% {\n    opacity: 0;\n\n    transform:\n      translateY(8px)\n      scale(0.8);\n  }\n\n\n  100% {\n    opacity: 1;\n\n    transform:\n      translateY(0)\n      scale(1);\n  }\n\n}\n\n\n@keyframes mudCenterStatusPulse {\n\n  0%,\n  100% {\n    transform:\n      scale(0.9);\n  }\n\n\n  50% {\n    transform:\n      scale(1.35);\n  }\n\n}\n\n\n/* =========================================================\n   RIGHT STATUS CONTENT\n========================================================= */\n\n.mud-status-content {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n\n  overflow: hidden;\n\n  box-sizing: border-box;\n\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n\n    gap: 8px;\n\n    width: 100%;\n    min-width: 0;\n\n    margin-bottom: 14px;\n  }\n\n\n  &__summary {\n    min-width: 0;\n  }\n\n\n  &__eyebrow {\n    display: block;\n\n    color:\n      #94a3b8;\n\n    font-size: 11px;\n    font-weight: 700;\n\n    letter-spacing: 0.55px;\n\n    text-transform: uppercase;\n\n    white-space: nowrap;\n  }\n\n\n  h4 {\n    display: flex;\n    align-items: baseline;\n    flex-wrap: wrap;\n\n    gap: 5px;\n\n    margin:\n      3px\n      0\n      0;\n\n    color:\n      #0f172a;\n\n    font-size: 24px;\n    font-weight: 800;\n\n    line-height: 1.2;\n\n    letter-spacing: -0.6px;\n\n\n    small {\n      color:\n        #64748b;\n\n      font-size: 10px;\n      font-weight: 600;\n\n      letter-spacing: 0;\n\n      white-space: nowrap;\n    }\n  }\n}\n\n\n/* =========================================================\n   LIVE / PAUSED BUTTON\n========================================================= */\n\n.mud-auto-rotate {\n  position: relative;\n\n  display: inline-flex;\n  align-items: center;\n\n  gap: 6px;\n\n  flex-shrink: 0;\n\n  min-height: 28px;\n\n  padding:\n    5px\n    9px;\n\n  border:\n    1px solid\n    #e2e8f0;\n\n  border-radius: 999px;\n\n  background:\n    #ffffff;\n\n  color:\n    #64748b;\n\n  font-family: inherit;\n\n  font-size: 9px;\n  font-weight: 700;\n\n  white-space: nowrap;\n\n  cursor: pointer;\n\n  transition:\n    border-color 0.2s ease,\n    background-color 0.2s ease,\n    color 0.2s ease,\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n\n\n  &:hover {\n    border-color:\n      #cbd5e1;\n\n    transform:\n      translateY(-1px);\n\n    box-shadow:\n      0\n      5px\n      14px\n      rgba(15, 23, 42, 0.07);\n  }\n\n\n  &__indicator {\n    position: relative;\n\n    width: 7px;\n    height: 7px;\n\n    flex: 0 0 7px;\n\n    border-radius: 50%;\n\n    background:\n      #94a3b8;\n  }\n\n\n  &.is-playing {\n    color:\n      #15803d;\n\n    border-color:\n      #bbf7d0;\n\n    background:\n      #f0fdf4;\n    font-size: 12px;\n    margin-top: 22px;\n\n\n    .mud-auto-rotate__indicator {\n      background:\n        #22c55e;\n\n\n      &::after {\n        position: absolute;\n\n        inset: -4px;\n\n        content: \"\";\n\n        border:\n          1px solid\n          rgba(34, 197, 94, 0.4);\n\n        border-radius: 50%;\n\n        animation:\n          mudLivePulse\n          1.6s\n          ease-out\n          infinite;\n      }\n    }\n  }\n\n\n  &.is-paused {\n    color:\n      #64748b;\n\n    border-color:\n      #e2e8f0;\n\n    background:\n      #f8fafc;\n    margin-top: 22px;\n  }\n}\n\n\n@keyframes mudLivePulse {\n\n  0% {\n    opacity: 1;\n\n    transform:\n      scale(0.5);\n  }\n\n\n  100% {\n    opacity: 0;\n\n    transform:\n      scale(1.8);\n  }\n\n}\n\n\n/* =========================================================\n   STATUS CARDS\n========================================================= */\n\n.mud-status-legend {\n  display: flex;\n  flex-direction: column;\n\n  gap: 8px;\n\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n\n\n  /* -----------------------------------------\n     CARD\n  ----------------------------------------- */\n\n  &__item {\n    position: relative;\n\n    display: block;\n\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n\n    padding:\n      10px\n      10px\n      9px;\n\n    overflow: hidden;\n\n    border:\n      1px solid\n      #e8edf4;\n\n    border-radius: 11px;\n\n    background:\n      #ffffff;\n\n    color: inherit;\n\n    text-align: left;\n\n    font-family: inherit;\n\n    cursor: pointer;\n\n    box-sizing: border-box;\n\n    transform:\n      translateX(0);\n\n    transition:\n      border-color 0.25s ease,\n      background-color 0.25s ease,\n      box-shadow 0.25s ease,\n      transform 0.25s ease;\n\n\n    &::before {\n      position: absolute;\n\n      top: 0;\n      left: 0;\n\n      width: 3px;\n      height: 100%;\n\n      content: \"\";\n\n      background:\n        var(--status-color);\n\n      opacity: 0;\n\n      transform:\n        scaleY(0.3);\n\n      transition:\n        opacity 0.25s ease,\n        transform 0.25s ease;\n    }\n\n\n    &:hover {\n      border-color:\n        var(--status-color);\n\n      box-shadow:\n        0\n        5px\n        14px\n        rgba(15, 23, 42, 0.06);\n    }\n\n\n    &.is-active {\n      border-color:\n        var(--status-color);\n\n      background:\n        linear-gradient(\n          90deg,\n          var(--status-light) 0%,\n          rgba(255, 255, 255, 0.98) 72%\n        );\n\n      box-shadow:\n        inset\n        3px\n        0\n        0\n        var(--status-color),\n        0\n        6px\n        16px\n        rgba(15, 23, 42, 0.06);\n\n\n      &::before {\n        opacity: 1;\n\n        transform:\n          scaleY(1);\n      }\n\n\n      .mud-status-legend__icon {\n        background:\n          var(--status-light);\n\n        transform:\n          scale(1.05);\n      }\n\n\n      .mud-status-legend__progress span {\n        opacity: 1;\n      }\n    }\n  }\n\n\n  /* -----------------------------------------\n     CARD TOP\n  ----------------------------------------- */\n\n  &__top {\n    display: grid;\n\n    grid-template-columns:\n      30px\n      minmax(0, 1fr)\n      auto;\n\n    align-items: center;\n\n    gap: 7px;\n\n    width: 100%;\n    min-width: 0;\n  }\n\n\n  /* -----------------------------------------\n     ICON\n  ----------------------------------------- */\n\n  &__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    width: 30px;\n    height: 30px;\n\n    flex: 0 0 30px;\n\n    border-radius: 9px;\n\n    background:\n      #f8fafc;\n\n    transition:\n      transform 0.25s ease,\n      background-color 0.25s ease;\n  }\n\n\n  &__dot {\n    width: 8px;\n    height: 8px;\n\n    border-radius: 50%;\n\n    background:\n      var(--status-color);\n\n    box-shadow:\n      0\n      0\n      0\n      4px\n      var(--status-light);\n  }\n\n\n  /* -----------------------------------------\n     LABEL + VALUE\n  ----------------------------------------- */\n\n  &__label {\n    display: flex;\n    align-items: center;\n\n    gap: 5px;\n\n    min-width: 0;\n\n\n    small {\n      min-width: 0;\n\n      overflow: hidden;\n\n      color:\n        #64748b;\n\n      font-size: 12px;\n      font-weight: 600;\n\n      white-space: nowrap;\n\n      text-overflow: ellipsis;\n    }\n\n\n    strong {\n      flex-shrink: 0;\n\n      color:\n        #0f172a;\n\n      font-size: 16px;\n      font-weight: 800;\n\n      line-height: 1;\n\n      letter-spacing: -0.3px;\n    }\n  }\n\n\n  /* -----------------------------------------\n     PERCENTAGE BADGE\n  ----------------------------------------- */\n\n  &__percentage {\n    flex-shrink: 0;\n\n    padding:\n      3px\n      6px;\n\n    border-radius: 999px;\n\n    background:\n      var(--status-light);\n\n    color:\n      var(--status-color);\n\n    font-size: 10px;\n    font-weight: 660;\n\n    white-space: nowrap;\n  }\n\n\n  /* -----------------------------------------\n     PROGRESS BAR\n  ----------------------------------------- */\n\n  &__progress {\n    height: 3px;\n\n    margin-top: 7px;\n    margin-left: 37px;\n\n    overflow: hidden;\n\n    border-radius: 999px;\n\n    background:\n      #f1f5f9;\n\n\n    span {\n      display: block;\n\n      height: 100%;\n\n      border-radius: inherit;\n\n      background:\n        var(--status-color);\n\n      opacity: 0.8;\n\n      transition:\n        width\n        0.8s\n        cubic-bezier(0.16, 1, 0.3, 1),\n        opacity\n        0.25s\n        ease;\n    }\n  }\n}\n\n\n/* =========================================================\n   DONUT TOOLTIP\n========================================================= */\n\n.mud-donut-tooltip {\n  min-width: 150px;\n\n  padding:\n    10px\n    12px;\n\n  border-radius: 10px;\n\n  background:\n    #ffffff;\n\n  box-shadow:\n    0\n    12px\n    30px\n    rgba(15, 23, 42, 0.14);\n\n\n  &__header {\n    display: flex;\n    align-items: center;\n\n    gap: 7px;\n\n    margin-bottom: 7px;\n\n    color:\n      #334155;\n\n    font-size: 11px;\n  }\n\n\n  &__dot {\n    width: 8px;\n    height: 8px;\n\n    flex: 0 0 8px;\n\n    border-radius: 50%;\n  }\n\n\n  &__body {\n    display: flex;\n    align-items: baseline;\n\n    gap: 5px;\n\n\n    strong {\n      color:\n        #0f172a;\n\n      font-size: 20px;\n      font-weight: 800;\n    }\n\n\n    span {\n      color:\n        #64748b;\n\n      font-size: 10px;\n      font-weight: 600;\n    }\n  }\n\n\n  &__percentage {\n    margin-top: 3px;\n\n    color:\n      #94a3b8;\n\n    font-size: 9px;\n    font-weight: 600;\n  }\n}\n\n\n/* =========================================================\n   RESPONSIVE - LARGE TABLET\n========================================================= */\n\n@media (max-width: 1400px) {\n\n  .mud-donut-layout {\n    grid-template-columns:\n      minmax(0, 1.25fr)\n      minmax(0, 1fr);\n\n    gap: 8px;\n  }\n\n\n  .mud-status-content {\n\n    h4 {\n      font-size: 21px;\n    }\n\n  }\n\n}\n\n\n/* =========================================================\n   RESPONSIVE - LAPTOP\n========================================================= */\n\n@media (max-width: 1200px) {\n\n  .mud-donut-layout {\n    grid-template-columns:\n      minmax(0, 1.15fr)\n      minmax(0, 1fr);\n\n    gap: 6px;\n  }\n\n\n  .mud-donut-chart-wrapper {\n    min-height: 250px;\n  }\n\n\n  .mud-donut-center-content {\n    width: 92px;\n    height: 92px;\n\n\n    &__status {\n      gap: 5px;\n\n      font-size: 9px;\n    }\n\n\n    &__value {\n      font-size: 27px;\n    }\n\n\n    &__percentage {\n\n      span {\n        font-size: 8px;\n      }\n\n\n      small {\n        font-size: 7px;\n      }\n\n    }\n  }\n\n\n  .mud-status-content {\n\n    &__header {\n      margin-bottom: 10px;\n    }\n\n\n    h4 {\n      font-size: 19px;\n\n\n      small {\n        font-size: 9px;\n      }\n    }\n  }\n\n\n  .mud-status-legend {\n    gap: 6px;\n\n\n    &__item {\n      padding:\n        8px\n        8px\n        7px;\n    }\n\n\n    &__top {\n      grid-template-columns:\n        27px\n        minmax(0, 1fr)\n        auto;\n\n      gap: 5px;\n    }\n\n\n    &__icon {\n      width: 27px;\n      height: 27px;\n\n      flex-basis: 27px;\n    }\n\n\n    &__label {\n\n      small {\n        font-size: 9px;\n      }\n\n\n      strong {\n        font-size: 14px;\n      }\n\n    }\n\n\n    &__percentage {\n      padding:\n        2px\n        5px;\n\n      font-size: 8px;\n    }\n\n\n    &__progress {\n      margin-left: 32px;\n    }\n\n  }\n\n}\n\n\n/* =========================================================\n   RESPONSIVE - TABLET / SMALLER CARD\n========================================================= */\n\n@media (max-width: 992px) {\n\n  .mud-donut-layout {\n    grid-template-columns: 1fr;\n\n    gap: 5px;\n  }\n\n\n  .mud-donut-chart-wrapper {\n    min-height: 235px;\n  }\n\n\n  .mud-status-content {\n    width: 100%;\n    max-width: 100%;\n  }\n\n}\n\n\n/* =========================================================\n   RESPONSIVE - MOBILE\n========================================================= */\n\n@media (max-width: 575px) {\n\n  .mud-donut-chart-wrapper {\n    min-height: 220px;\n  }\n\n\n  .mud-donut-center-content {\n    width: 88px;\n    height: 88px;\n\n\n    &__status {\n      font-size: 8px;\n    }\n\n\n    &__value {\n      font-size: 25px;\n    }\n\n\n    &__percentage {\n\n      small {\n        display: none;\n      }\n\n    }\n  }\n\n\n  .mud-status-content {\n\n    &__header {\n      align-items: center;\n    }\n\n\n    h4 {\n      font-size: 20px;\n    }\n\n  }\n\n\n  .mud-status-legend {\n\n    &__item {\n      padding: 9px;\n    }\n\n\n    &__top {\n      grid-template-columns:\n        28px\n        minmax(0, 1fr)\n        auto;\n    }\n\n\n    &__icon {\n      width: 28px;\n      height: 28px;\n    }\n\n  }\n\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
